export let curLan = window.localStorage.getItem('app-language') || 'zh'; // 当前语言

export function setCurLan(lan) {
  curLan = lan;
  window.localStorage.setItem('app-language', lan);
}

export function setCurLanI18n(lan) {
  // 语言代码映射
  const i18nMap = {
    'zh': 'zh-CN',
    'en': 'en-US'
  };
  //需要转换下i18n的格式 框架自带的时间插件等需要根据这个来切换语言
  window.localStorage.setItem('local', i18nMap[lan] || 'zh-CN');
}

export function getI18nLang(lan) {
  // 语言代码映射
  const i18nMap = {
    'zh': 'zh-CN',
    'en': 'en-US'
  };
  return i18nMap[lan] || 'zh-CN';
}

export const lanArr = [
  { value: 'zh', label: {zh:'中文',en:'中文'}, name: {zh:'中',en:'Chinese'} },
  { value: 'en', label: {zh:'English',en:'English'}, name: {zh:'英',en:'English'} }
];

export function t(key) {
  if (!language[key]) {
    console.warn(`Translation key "${key}" not found`);
    return key;
  }
  return language[key][curLan] || language[key]['zh'] || key;
}


const language = {
  home: { zh: '首页', en: 'Home Page' },
  home_welcome_title: { zh: '欢迎', en: 'Welcome' },
  home_welcome_subtitle: { zh: '欢迎来到机器人管控平台', en: 'Welcome to Robot Control System' },
  home_welcome_description: { zh: '一个强大的平台用于管理和监控机器人运营', en: 'A powerful platform for managing and monitoring robotic operations' },
  home_status: { zh: '状态', en: 'Status' },
  home_ready: { zh: '就绪', en: 'Ready' },
  home_platform_status: { zh: '平台', en: 'Platform' },
  home_system_normal: { zh: '正常', en: 'Normal' },
  home_version: { zh: '版本', en: 'Version' },
  home_version_info: { zh: '版本信息', en: 'Version Info' },
  home_version_front: { zh: '客户端', en: 'Client' },
  home_version_back: { zh: '服务端', en: 'Server' },
  home_version_loading: { zh: '获取中...', en: 'Loading...' },
  home_version_match: { zh: '一致', en: 'Matched' },
  home_version_mismatch: { zh: '异常', en: 'Mismatch' },
  home_language: { zh: '语言', en: 'Language' },
  home_robot_status: { zh: '机器人', en: 'Robot' },
  home_robot_total: { zh: '总数', en: 'Total' },
  home_quick_menu: { zh: '快捷菜单', en: 'Quick Menu' },
  home_add_quick_menu: { zh: '添加快捷菜单', en: 'Add Quick Menu' },
  home_quick_menu_settings: { zh: '快捷菜单设置', en: 'Quick Menu Settings' },
  home_quick_menu_clear_cache_warning: { zh: '温馨提示：清空浏览器缓存或localStorage会导致快捷菜单消失，需要重新设置。', en: 'Warning: Clearing browser cache or localStorage will cause quick menus to disappear and need to be reset.' },
  home_current_quick_menus: { zh: '当前快捷菜单', en: 'Current Quick Menus' },
  home_no_quick_menus: { zh: '暂无快捷菜单', en: 'No quick menus yet' },
  home_available_menus: { zh: '可选菜单', en: 'Available Menus' },
  home_search_menu: { zh: '搜索菜单', en: 'Search menus' },
  home_save_failed: { zh: '保存失败', en: 'Save failed' },
  home_max_quick_menus_reached: { zh: '最多只能设置{max}个快捷菜单', en: 'Maximum {max} quick menus allowed' },
  home_menus_removed_due_to_permission: { zh: '部分快捷菜单因权限变化已被移除', en: 'Some quick menus have been removed due to permission changes' },
  messageCenter: { zh: '消息中心', en: 'Message Center' },
  empty: { zh:'暂无数据', en:'No data available' },

  // Dashboard / monitor
  dashboard_cpuOverview: { zh: 'CPU概览', en: 'CPU Overview' },
  dashboard_coreDetails: { zh: '核心详情', en: 'Core Details' },
  dashboard_totalUsage: { zh: '总使用率', en: 'TUR' },
  dashboard_totalCores: { zh: '总核数', en: 'Tot.Cores' },
  dashboard_use: { zh: '使用率', en: 'Use' },
  dashboard_temp: { zh: '温度', en: 'Temp' },
  dashboard_freq: { zh: '频率', en: 'Freq' },
  dashboard_onlineTip: { zh: '机器人在线 - 支持实时监控与历史查询', en: 'Robot online - supports real-time monitoring and history query' },
  dashboard_offlineTip: { zh: '机器人离线 - 仅支持历史数据查询', en: 'Robot offline - history data only' },
  dashboard_statusHistoryTitle: { zh: '实时状态历史查询', en: 'Real-time status history query' },
  dashboard_networkHistoryTitle: { zh: '网卡信息历史查询', en: 'Network card history query' },
  dashboard_timeRange: { zh: '时间范围', en: 'Time range' },
  dashboard_selectTimeRangePlaceholder: { zh: '选择时间范围', en: 'Select time range' },
  dashboard_device: { zh: '设备', en: 'Device' },
  dashboard_paramName: { zh: '参数名称', en: 'Parameter name' },
  dashboard_search: { zh: '查询', en: 'Search' },
  dashboard_reset: { zh: '重置', en: 'Reset' },
  dashboard_loading: { zh: '等待数据...', en: 'Awaiting data...' },
  dashboard_totalRecords: { zh: '总记录', en: 'Total records' },
  dashboard_perPage: { zh: '每页', en: 'Per page' },
  dashboard_jumpTo: { zh: '跳至', en: 'Jump to' },
  dashboard_selectTimeAndSearch: { zh: '请选择时间范围并点击查询按钮', en: 'Please select a time range and click the search button' },
  dashboard_timeRangeMaxOneWeek: { zh: '时间范围最多只能选择一周', en: 'Time range can be at most one week' },
  dashboard_pleaseSelectTimeRange: { zh: '请选择时间范围', en: 'Please select a time range' },
  dashboard_querying: { zh: '查询中...', en: 'Query in progress...' },
  dashboard_queryFailed: { zh: '查询失败', en: 'Query failed' },
  dashboard_inputValidPageRange: { zh: '请输入 1-{max} 之间的页码', en: 'Please enter a page number between 1 and {max}' },
  dashboard_dataTime: { zh: '数据时间', en: 'Data time' },
  dashboard_deviceId: { zh: '设备ID', en: 'Device ID' },
  dashboard_deviceName: { zh: '设备名称', en: 'Device name' },
  dashboard_paramValue: { zh: '参数值', en: 'Parameter value' },
  dashboard_robotCode: { zh: '机器人编码', en: 'Robot code' },
  dashboard_last1Hour: { zh: '最近1小时', en: 'Last 1 hour' },
  dashboard_last3Hours: { zh: '最近3小时', en: 'Last 3 hours' },
  dashboard_last6Hours: { zh: '最近6小时', en: 'Last 6 hours' },
  dashboard_last24Hours: { zh: '最近24小时', en: 'Last 24 hours' },
  dashboard_last7Days: { zh: '最近7天', en: 'Last 7 days' },
  dashboard_enableStatus: { zh: '启用状态', en: 'Enable status' },
  dashboard_networkInfoColumn: { zh: '网卡信息', en: 'Network card info' },
  dashboard_bandwidth: { zh: '带宽', en: 'Bandwidth' },
  dashboard_upload: { zh: '上行', en: 'Upload' },
  dashboard_download: { zh: '下行', en: 'Download' },
  dashboard_latency: { zh: '时延', en: 'Latency' },
  dashboard_jitter: { zh: '抖动', en: 'Jitter' },
  dashboard_packetLoss: { zh: '丢包', en: 'Packet loss' },
  dashboard_enabled: { zh: '启用', en: 'Enabled' },
  dashboard_disabled: { zh: '未启用', en: 'Disabled' },
  dashboard_selectDevice: { zh: '选择设备', en: 'Select device' },
  dashboard_pleaseSelectDevice: { zh: '请选择设备', en: 'Please select a device' },
  dashboard_selectErrorCode: { zh: '选择错误码', en: 'Select error code' },
  errorCode: { zh: '错误码', en: 'Error code' },
  dashboard_noData: { zh: '暂无数据', en: 'No data' },
  dashboard_deviceOfflineStatus: { zh: '设备离线状态', en: 'Device offline status' },
  dashboard_deviceStatus: { zh: '设备状态', en: 'Device Status' },
  dashboard_hostStatus: { zh: '主机状态', en: 'Host Status' },
  dashboard_mileageStatus: { zh: '里程状态', en: 'Mileage Status' },
  dashboard_runningStatus: { zh: '运行状态', en: 'Running Status' },
  dashboard_methane: { zh: '甲烷状态', en: 'Mileage Status' },
  dashboard_mileage_category: { zh: '里程数据', en: 'Mileage Data' },
  dashboard_methane_category: { zh: '甲烷数据', en: 'Methane Data' },
  dashboard_methaneStatus: { zh: '甲烷状态', en: 'Methane Status' },
  dashboard_methane_concentration: { zh: '甲烷浓度', en: 'Methane Concentration' },
  dashboard_light_intensity: { zh: '光强', en: 'Light Intensity' },
  dashboard_onlineOfflineStatus: { zh: '上下线状态', en: 'Online/Offline Status' },
  dashboard_totalPowerOnSeconds: { zh: '总运行时间（h）', en: 'Total Runtime (h)' },
  dashboard_currentPowerOnSeconds: { zh: '当前开机运行时间（h）', en: 'Current Runtime (h)' },
  dashboard_totalDrivingDistance: { zh: '总里程数（m）', en: 'Total Mileage（m）' },
  dashboard_currentDrivingDistance: { zh: '当前行驶距离（m）', en: 'Current Distance（m）' },
  dashboard_totalPowerOnTimes: { zh: '总开机次数', en: 'Total Power On Times' },
  dashboard_totalPowerOnDays: { zh: '总开机天数', en: 'Total Power On Days' },
  dashboard_createTime: { zh: '记录时间', en: 'Record Time' },
  dashboard_noDeviceOffline: { zh: '无设备离线', en: 'No device offline' },
  dashboard_noDeviceError: { zh: '暂无设备错误', en: 'No device error' },
  dashboard_noRunningError: { zh: '暂无运行错误', en: 'No running error' },
  dashboard_deviceErrorTab: { zh: '设备错误', en: 'Device error' },
  dashboard_runningErrorTab: { zh: '运行错误', en: 'Running error' },
  dashboard_deviceOriginalName: { zh: '设备原始名称', en: 'Original device name' },
  dashboard_statusLabel: { zh: '状态', en: 'Status' },
  dashboard_online: { zh: '在线', en: 'Online' },
  dashboard_offline: { zh: '离线', en: 'Offline' },
  dashboard_mqttConnected: { zh: '连接成功', en: 'Connected' },
  dashboard_mqttSubscribed: { zh: '订阅就绪', en: 'Subscribed' },
  dashboard_mqttOffline: { zh: '下线', en: 'Offline' },
  dashboard_offlineReason: { zh: '下线原因', en: 'Offline reason' },
  dashboard_disconnected: { zh: '断连', en: 'Disconnected' },
  dashboard_errorDesc: { zh: '错误描述', en: 'Error description' },
  dashboard_paramValueLabel: { zh: '参数值', en: 'Value' },
  dashboard_deviceIdLabel: { zh: '设备ID', en: 'Device ID' },
  dashboard_levelRecovered: { zh: '已恢复', en: 'Recovered' },
  dashboard_levelWarn: { zh: '警告', en: 'Warning' },
  dashboard_levelError: { zh: '错误', en: 'Error' },
  dashboard_levelFatal: { zh: '严重', en: 'Critical' },
  dashboard_levelUnknown: { zh: '未知', en: 'Unknown' },
  dashboard_unitCount: { zh: '条', en: '' },
  dashboard_searchPlaceholder: { zh: '搜索名称或序列号', en: 'Search name or serial number' },
  dashboard_clear: { zh: '清空', en: 'Clear' },
  dashboard_delete: { zh: '删除', en: 'Delete' },
  dashboard_confirm: { zh: '确定', en: 'Confirm' },
  dashboard_cancel: { zh: '取消', en: 'Cancel' },
  dashboard_warning: { zh: '警告', en: 'Warning' },
  dashboard_confirmDelete: { zh: '确认删除吗?', en: 'Confirm to delete?' },
  dashboard_deleteSuccess: { zh: '删除成功', en: 'Delete successfully' },
  dashboard_deleteFailed: { zh: '删除失败', en: 'Delete failed' },
  dashboard_scrollLeft: { zh: '左滚动', en: 'Scroll left' },
  dashboard_scrollRight: { zh: '右滚动', en: 'Scroll right' },
  dashboard_realtimeMonitor: { zh: '实时监控', en: 'Real-time monitor' },
  dashboard_historyQuery: { zh: '历史查询', en: 'History query' },
  dashboard_statusTab: { zh: '状态', en: 'Status' },
  dashboard_errorTab: { zh: '错误', en: 'Error' },
  dashboard_emergencyTab: { zh: '通知', en: 'Notification' },
  dashboard_networkTab: { zh: '网卡', en: 'Network' },
  dashboard_realtimePrefix: { zh: '实时', en: 'Realtime ' },
  dashboard_historyPrefix: { zh: '历史', en: 'History ' },
  dashboard_modeStatusSuffix: { zh: '状态', en: 'status' },
  dashboard_modeErrorSuffix: { zh: '错误', en: 'error' },
  dashboard_modeEmergencySuffix: { zh: '通知', en: 'notification' },
  dashboard_modeNetworkSuffix: { zh: '网卡', en: 'network' },
  dashboard_realtimeStatusDetail: { zh: '实时监控机器人运行状态', en: 'Monitor robot running status in real time' },
  dashboard_realtimeErrorDetail: { zh: '实时监控错误和告警信息', en: 'Monitor errors and alarms in real time' },
  dashboard_realtimeNetworkDetail: { zh: '实时监控网卡状态信息', en: 'Monitor network card status in real time' },
  dashboard_historyStatusDetail: { zh: '查询历史运行状态记录', en: 'Query historical running status records' },
  dashboard_historyNetworkDetail: { zh: '查询网卡历史记录', en: 'Query historical network card records' },
  dashboard_historyErrorDetail: { zh: '查询历史错误和告警记录', en: 'Query historical error and alarm records' },
  dashboard_historyEmergencyDetail: { zh: '查看历史通知记录', en: 'View historical notification records' },
  dashboard_selectRobotTitle: { zh: '请选择机器人', en: 'Please select a robot' },
  dashboard_selectRobotSubtitle: { zh: '从上方选择一个机器人开始监控信息', en: 'Select a robot above to start monitoring' },
  emergencyNotificationTitle: { zh: '紧急通知', en: 'Emergency Notification' },
  emergencyNotificationDesc: { zh: '动作:', en: 'Action:' },
  alertInfoNotificationTitle: { zh: '告警通知', en: 'Alert Notification' },
  alertInfoType: { zh: '告警类型', en: 'Alert type' },
  alertInfoMessage: { zh: '告警消息', en: 'Alert message' },
  alertInfoObstacleAvoidanceFailed: { zh: '避障失败', en: 'Obstacle avoidance failed' },
  alertInfoBehaviorProhibitionFailed: { zh: '行为拒止失败', en: 'Behavior prohibition failed' },
  reason: { zh: '原因', en: 'Reason' },
  stop_moving: { zh: '急停', en: 'stop_moving' },
  stop_moving_recover: { zh: '急停恢复', en: 'stop_moving_recover' },
  stop_moving_disconnection: { zh: '设备断联', en: 'devices_disconnection' },
  stop_moving_recover_disconnection: { zh: '设备断联恢复', en: 'devices_disconnection_recover' },
  dashboard_errorNotificationTitle: { zh: '设备出现严重错误', en: 'Serious device error occurred' },
  dashboard_errorNotificationDeviceTitle: { zh: '设备出现严重错误', en: 'Serious device error occurred' },
  dashboard_errorNotificationDeviceDesc: { zh: '请查看错误监控页面', en: 'Please check the error monitor page' },
  dashboard_errorNotificationRunningTitle: { zh: '运行出现严重错误', en: 'Serious running error occurred' },
  dashboard_errorNotificationRunningDesc: { zh: '请查看错误监控页面', en: 'Please check the error monitor page' },
  dashboard_ignoreThisTime: { zh: '本次忽略', en: 'Ignore this time' },
  dashboard_ignoreHint: { zh: '下次访问仍会检测', en: 'Will still be checked next time' },
  dashboard_robotOfflineTitle: { zh: '机器人离线', en: 'Robot offline' },
  dashboard_robotOfflineDesc: { zh: '{name} 已离线，实时监控不可用，已自动切换到历史查询模式', en: '{name} is offline, real-time monitoring is unavailable, switched to history mode automatically' },
  dashboard_robotOnlineTitle: { zh: '机器人上线', en: 'Robot online' },
  dashboard_robotOnlineDesc: { zh: '{name} 已上线，可以切换到实时监控模式', en: '{name} is online, you can switch to real-time monitoring' },
  dashboard_robotStatusChangeNotFound: { zh: '未找到机器人: {code}', en: 'Robot not found: {code}' },
  dashboard_robotStatusChanged: { zh: '机器人 {name} ({code}) 状态变更: {old} -> {new}', en: 'Robot {name} ({code}) status changed: {old} -> {new}' },
  dashboard_robotStatusOnlineText: { zh: '上线', en: 'online' },
  dashboard_robotStatusOfflineText: { zh: '离线', en: 'offline' },
  dashboard_robotStatusInfoTitle: { zh: '机器人{statusText}', en: 'Robot {statusText}' },
  dashboard_robotStatusInfoDesc: { zh: '{name} 已{statusText}', en: '{name} is {statusText}' },
  dashboard_expandModule: { zh: '点击展开模块', en: 'Expand' },
  dashboard_collapseModule: { zh: '点击收缩模块', en: 'Collapse' },
  dashboard_batteryAndSensors: { zh: '电池与传感器', en: 'Bat. & Sensors' },
  dashboard_cameraModule: { zh: '相机模块', en: 'Cam. Module' },
  dashboard_motorModule: { zh: '电机模块', en: 'Mtr. Module' },
  dashboard_collisionDetection: { zh: '碰撞检测', en: 'Collision Detection' },
  dashboard_collisionStatus: { zh: '碰撞状态', en: 'Collision Status' },
  dashboard_collisionDetected: { zh: '检测到碰撞', en: 'Collision Detected' },
  dashboard_collisionNormal: { zh: '正常', en: 'Normal' },
  dashboard_collisionDataTime: { zh: '数据时间戳', en: 'Data Time' },
  dashboard_collisionTime: { zh: '碰撞时间', en: 'Time' },
  dashboard_collisionType: { zh: '类型', en: 'Type' },
  dashboard_collisionAcceleration: { zh: '加速度', en: 'Acceleration' },
  dashboard_collisionAccelerationX: { zh: 'X分量', en: 'X Component' },
  dashboard_collisionAccelerationY: { zh: 'Y分量', en: 'Y Component' },
  dashboard_collisionAccelerationZ: { zh: 'Z分量', en: 'Z Component' },
  
  // 机器自检
  dashboard_selfCheck: { zh: '机器自检', en: 'Self Check' },
  dashboard_selfCheckTime: { zh: '自检时间', en: 'Check Time' },
  dashboard_selfCheckType: { zh: '触发类型', en: 'Trigger Type' },
  dashboard_selfCheckTypeBootup: { zh: '开机自检', en: 'Bootup Check' },
  dashboard_selfCheckTypePlatform: { zh: '平台触发', en: 'Platform Trigger' },
  dashboard_selfCheckStatus: { zh: '自检状态', en: 'Status' },
  dashboard_selfCheckResult: { zh: '自检结果', en: 'Result' },
  dashboard_selfCheckSuccess: { zh: '成功', en: 'Success' },
  dashboard_selfCheckFailed: { zh: '失败', en: 'Failed' },
  dashboard_startSelfCheck: { zh: '开始自检', en: 'Start Check' },
  dashboard_selfCheckStarted: { zh: '自检已启动', en: 'Self check started' },
  dashboard_selfCheckCompleted: { zh: '已完成', en: 'Completed' },
  dashboard_selfCheckPending: { zh: '等待上报', en: 'Pending' },
  dashboard_selfCheckOk: { zh: '正常', en: 'OK' },
  dashboard_selfCheckWarn: { zh: '警告', en: 'Warn' },
  dashboard_selfCheckError: { zh: '错误', en: 'Error' },
  dashboard_selfCheckFatal: { zh: '严重', en: 'Fatal' },
  dashboard_selfCheckDetail: { zh: '自检详情', en: 'Check Details' },
  dashboard_viewDetail: { zh: '查看详情', en: 'View Details' },
  dashboard_hideDetail: { zh: '收起详情', en: 'Hide Details' },
  dashboard_items: { zh: '项', en: 'items' },
  dashboard_operation: { zh: '操作', en: 'Operation' },
  dashboard_noDetailData: { zh: '暂无详细数据', en: 'No detail data' },
  
  // 自检参数key翻译 - 只保留API文档中明确出现的字段
  selfCheck_is_online: { zh: '是否在线', en: 'Is Online' },
  selfCheck_is_online_0: { zh: '离线', en: 'Offline' },
  selfCheck_is_online_1: { zh: '在线', en: 'Online' },
  selfCheck_is_power_on: { zh: '是否上电', en: 'Is Power On' },
  selfCheck_is_power_on_0: { zh: '未上电', en: 'Power Off' },
  selfCheck_is_power_on_1: { zh: '已上电', en: 'Power On' },
  selfCheck_is_enabled: { zh: '是否使能', en: 'Is Enabled' },
  selfCheck_is_enabled_0: { zh: '未使能', en: 'Disabled' },
  selfCheck_is_enabled_1: { zh: '已使能', en: 'Enabled' },
  selfCheck_is_in_mode: { zh: '是否进入具体模式', en: 'Is In Specific Mode' },
  selfCheck_is_in_mode_0: { zh: '未进入具体模式', en: 'Not In Specific Mode' },
  selfCheck_is_in_mode_1: { zh: '已进入具体模式', en: 'In Specific Mode' },
  selfCheck_latency_ms: { zh: '时延', en: 'Latency' },
  selfCheck_packet_loss_rate: { zh: '丢包率', en: 'Packet Loss Rate' },
  selfCheck_total_logical_cores: { zh: '总核数', en: 'Total Cores' },
  selfCheck_cpu_total_usage: { zh: 'CPU总使用率', en: 'CPU Usage' },
  selfCheck_total_capacity: { zh: '总容量', en: 'Total Capacity' },
  selfCheck_free_capacity: { zh: '空闲容量', en: 'Free Capacity' },
  selfCheck_usage_rate: { zh: '使用率', en: 'Usage Rate' },
  selfCheck_total: { zh: '总容量', en: 'Total' },
  selfCheck_free: { zh: '空闲容量', en: 'Free' },
  selfCheck_ls_online: { zh: '是否在线', en: 'Is Online' },
  selfCheck_devices_total_count: { zh: '总设备数量', en: 'Total Devices' },
  selfCheck_disconnected_devices_count: { zh: '设备断联数量', en: 'Disconnected Devices' },
  selfCheck_param_errors_count: { zh: '设备参数错误个数', en: 'Param Errors' },
  selfCheck_devices_errors_count: { zh: '设备错误数量', en: 'Device Errors' },
  
  // 模块日志
  dashboard_moduleLog: { zh: '模块日志', en: 'Module Log' },
  dashboard_logTime: { zh: '日志时间', en: 'Log Time' },
  dashboard_moduleName: { zh: '模块名称', en: 'Module Name' },
  dashboard_pleaseSelectModule: { zh: '请选择一个模块', en: 'Please select a module' },
  dashboard_logLevel: { zh: '日志级别', en: 'Log Level' },
  dashboard_logContent: { zh: '日志内容', en: 'Log Content' },
  dashboard_logLevelInfo: { zh: '信息', en: 'Info' },
  dashboard_logLevelWarn: { zh: '警告', en: 'Warn' },
  dashboard_logLevelError: { zh: '错误', en: 'Error' },
  dashboard_logLevelDebug: { zh: '调试', en: 'Debug' },
  dashboard_export: { zh: '导出', en: 'Export' },
  dashboard_exporting: { zh: '导出中', en: 'Exporting' },
  dashboard_downloading: { zh: '正在下载', en: 'Downloading' },
  dashboard_downloadingFile: { zh: '正在下载文件...', en: 'Downloading file...' },
  dashboard_exportLog: { zh: '导出日志', en: 'Export Log' },
  dashboard_exportSuccess: { zh: '导出成功', en: 'Export success' },
  dashboard_exportFailed: { zh: '导出失败', en: 'Export failed' },
  dashboard_exportTimeRangeMax3Days: { zh: '导出时间范围最长支持3天', en: 'Export time range supports up to 3 days' },
  dashboard_exportPDF: { zh: '导出PDF', en: 'Export PDF' },
  dashboard_generatingPDF: { zh: '正在生成PDF...', en: 'Generating PDF...' },
  dashboard_exportingPDF: { zh: '正在导出...', en: 'Exporting...' },
  
  // 日志导出任务
  dashboard_logTaskId: { zh: '任务ID', en: 'Task ID' },
  dashboard_logStartDate: { zh: '日志起始', en: 'Log Start' },
  dashboard_logEndDate: { zh: '日志截止', en: 'Log End' },
  dashboard_logDateRange: { zh: '日期范围', en: 'Date Range' },
  dashboard_logModules: { zh: '导出模块', en: 'Modules' },
  dashboard_logStatus: { zh: '任务状态', en: 'Status' },
  dashboard_logProgress: { zh: '进度', en: 'Progress' },
  dashboard_logCreateTime: { zh: '创建时间', en: 'Create Time' },
  dashboard_logAllModules: { zh: '全部模块', en: 'All Modules' },
  dashboard_logTaskStatus: { zh: '任务状态', en: 'Task Status' },
  dashboard_logStatusAll: { zh: '全部', en: 'All' },
  dashboard_logStatusInit: { zh: '初始化', en: 'Init' },
  dashboard_logStatusUploading: { zh: '上传中', en: 'Uploading' },
  dashboard_logStatusPacking: { zh: '打包中', en: 'Packing' },
  dashboard_logStatusSuccess: { zh: '成功', en: 'Success' },
  dashboard_logStatusFail: { zh: '失败', en: 'Failed' },
  dashboard_download: { zh: '下载', en: 'Download' },
  dashboard_deviceStatusData: { zh: '设备状态数据', en: 'Device Status Data' },
  
  dashboard_networkCardInfo: { zh: '网卡信息', en: 'NIC Info' },
  dashboard_throughputUp: { zh: '上行吐吞量', en: 'Throughput Up' },
  dashboard_throughputDown: { zh: '下行吐吞量', en: 'Throughput‌ DL' },
  dashboard_usageUp: { zh: '上行利用率', en: 'Usage Up' },
  dashboard_usageDown: { zh: '下行利用率', en: 'Usage Down' },
  dashboard_packetLossRate: { zh: '丢包率', en: 'Pkt Loss Rate' },

	// WorkVision video play mode
	workVision_playMode_webrtc: { zh: 'WebRTC', en: 'WebRTC' },
	workVision_playMode_rtmp: { zh: 'RTMP', en: 'RTMP' },
	workVision_webrtc_signalingConnectError: { zh: '信令服务连接失败，请刷新重试', en: 'Signaling service connection failed. Please refresh and try again.' },
	workVision_webrtc_deviceResponseTimeout: { zh: '设备响应超时，请检查设备是否在线', en: 'Device response timed out. Please check whether the device is online.' },
	workVision_playMode_flv: { zh: 'FLV', en: 'FLV' },
	workVision_playMode_hls: { zh: 'HLS', en: 'HLS' },
	workVision_playMode_bak: { zh: '备用', en: 'Backup' },
	workVision_switchPlayModeTitle: { zh: '切换播放模式（当前：{mode}）', en: 'Switch play mode (Current: {mode})' },

	// WorkVision WebRTC player toolbar
	workVision_player_mute: { zh: '静音', en: 'Mute' },
	workVision_player_unmute: { zh: '开启声音', en: 'Unmute' },
	workVision_player_fullscreen: { zh: '全屏', en: 'Fullscreen' },
	workVision_player_pause: { zh: '暂停', en: 'Pause' },
	workVision_player_resume: { zh: '继续', en: 'Resume' },
	workVision_player_stop: { zh: '停止', en: 'Stop' },
	workVision_player_volume: { zh: '音量', en: 'Volume' },
	
	// Jessibuca player controls
	jessibuca_play: { zh: '播放', en: 'Play' },
	jessibuca_pause: { zh: '暂停', en: 'Pause' },
	jessibuca_fullscreen: { zh: '全屏', en: 'Fullscreen' },
	jessibuca_exitFullscreen: { zh: '退出全屏', en: 'Exit Fullscreen' },
	jessibuca_mute: { zh: '静音', en: 'Mute' },
	jessibuca_unmute: { zh: '开启声音', en: 'Unmute' },
  
  // RobotGlobe related translations
  robotGlobe_loading: { zh: '加载中...', en: 'Loading...' },
  robotGlobe_loadFailed: { zh: '资源加载失败，请刷新重试', en: 'Resource loading failed, please refresh and try again' },
  robotGlobe_retryLoad: { zh: '刷新重试', en: 'Retry' },
  robotGlobe_initFailed: { zh: '初始化失败，请刷新重试', en: 'Initialization failed, please refresh and try again' },
  
  // Memory related translations
  dashboard_cpuInfo: { zh: 'CPU信息', en: 'CPU Info' },
  dashboard_memoryInfo: { zh: '内存信息', en: 'Memory' },
  dashboard_usageRate: { zh: '使用率', en: 'Usage' },
  dashboard_memoryUsageRate: { zh: '内存使用率', en: 'Mem. Usage' },
  dashboard_memoryCapacity: { zh: '内存容量', en: 'Mem. Capacity' },
  dashboard_memoryDetails: { zh: '内存详情', en: 'Mem. Details' },
  dashboard_memoryTotal: { zh: '总内存', en: 'Total' },
  dashboard_memoryUsed: { zh: '已使用', en: 'Used' },
  dashboard_memoryFree: { zh: '空闲', en: 'Free' },
  dashboard_memoryBuffer: { zh: '缓冲区', en: 'Buffer' },
  dashboard_memoryCached: { zh: '缓存', en: 'Cached' },
  dashboard_memoryUser: { zh: '用户使用', en: 'User' },
  dashboard_memoryShared: { zh: '共享内存', en: 'Shared' },
  dashboard_memoryLocked: { zh: '锁定内存', en: 'Locked' },
  dashboard_memoryAndDisk: { zh: '内存与磁盘', en: 'Mem&Disk' },

  // Disk related translations
  dashboard_diskInfo: { zh: '磁盘信息', en: 'Disk Info' },
  dashboard_mountPoint: { zh: '挂载点', en: 'Mount Point' },
  dashboard_fileSystem: { zh: '文件系统', en: 'File System' },
  dashboard_totalCapacity: { zh: '总容量', en: 'Total Capacity' },
  dashboard_freeCapacity: { zh: '空闲容量', en: 'Free Capacity' },
  dashboard_usageRate: { zh: '使用率', en: 'Usage Rate' },
  dashboard_mountInfo: { zh: '挂载信息', en: 'Mount Info' },
  dashboard_capacityInfo: { zh: '容量信息', en: 'Capacity Info' },

  sys1: { zh: '管理系统', en: 'Mgmt System' },
  reLogin: { zh: '登录信息已过期，请重新登录', en: 'Login information has expired, please log in again' },
  extraReLogin: { zh: '登录信息已过期，请检查入参信息是否正确', en: 'Login information has expired, please check the input parameters' },
  intError: { zh: '网络错误，请联系管理员', en: 'Network error, please contact the administrator' },
  timeOut: { zh: '请求超时', en: 'request timeout' },
  serverError: { zh: '服务器错误', en: 'Server error' },
  sessionExpired: { zh: '会话已过期', en: 'Session expired' },

  // 外部登录相关
  externalLogin: { zh: '第三方接入登录', en: 'External access login' },
  verifyingAccess: { zh: '正在验证访问权限...', en: 'Verifying access permissions...' },
  tokenRequired: { zh: 'Token参数缺失', en: 'Token parameter is required' },
  tenantIdRequired: { zh: '租户ID参数缺失', en: 'Tenant id parameter is required' },
  tenantNotFound: { zh: '租户信息获取失败', en: 'Failed to get tenant information' },
  accessVerified: { zh: '访问验证成功，正在跳转...', en: 'Access verified successfully, redirecting...' },
  verificationFailed: { zh: '验证失败，请联系管理员', en: 'Verification failed, please contact administrator' },
  tenantName: { zh: '租户名称', en: 'Tenant name' },
  description: { zh: '描述', en: 'Description' },
  sessionExpiredMessage: { zh: '您的登录信息已过期，请重新登录。', en: 'Your login information has expired, please log in again.' },
  noMenuPermission: { zh: '没有菜单权限', en: 'No menu permission' },
  noMenuPermissionMessage: { zh: '您当前没有任何菜单访问权限，请联系管理员分配权限后重新登录。', en: 'You currently have no menu access permissions. Please contact the administrator to assign permissions and log in again.' },
  login: { zh: '登录', en: 'Login' },
  cdgl: { zh: '菜单管理', en: 'Menu Management' },
  zhName: { zh: '中文名称', en: 'Chinese name' },
  enName: { zh: '英文名称', en: 'English name' },
  delete: { zh: '删除', en: 'Delete' },
  sfsc: { zh: '是否删除', en: 'Whether to delete' },
  wlcm: { zh: '欢迎登录机器人管控平台', en: 'Welcome to log in to the robot management and control platform' },
  jd: { zh: '经度', en: 'Longitude' },
  wd: { zh: '纬度', en: 'Latitude' },
  sfsfjq: { zh: '测试三方警情', en: 'Test the police situation of the third party' },
  sfsfrwfs: { zh: '测试三方任务发送', en: 'Test the task sending of the third party' },
  data: { zh: '数据', en: 'Data' },
  updatePwd: { zh: '修改密码', en: 'Change password' },
  logout: { zh: '退出登录', en: 'Logout' },
  updateLoginPwd: { zh: '修改登录密码', en: 'Change login password' },
  oldPwd: { zh: '原密码', en: 'Old password' },
  newPwd: { zh: '新密码', en: 'New password' },
  confirmNewPwd: { zh: '确认密码', en: 'Confirm password' },
  inputCurrentPwd: { zh: '请输入当前密码', en: 'Please enter current password' },
  inputNewPwd: { zh: '请输入新密码', en: 'Please enter new password' },
  inputNewPwdAgain: { zh: '请再次输入新密码', en: 'Please enter new password again' },
  pwdNotMatch: { zh: '两次输入密码不一致', en: 'The passwords entered twice do not match' },
  inputOldPwd: { zh: '请输入原密码', en: 'Please enter old password' },
  minSixChar: { zh: '密码长度不能小于6位', en: 'Password cannot be less than 6 characters' },
  maxFifteenChar: { zh: '密码长度不能超过15位', en: 'Password cannot exceed 15 characters' },
  maxThreeConsecutive: { zh: '密码不能包含超过3位的连续数字序列（正序或倒序）', en: 'Password cannot contain more than 3 consecutive digits (ascending or descending)' },
  minOneLetter: { zh: '密码必须包含至少一个英文字母', en: 'Password must contain at least one letter' },
  minEightChar: { zh: '密码长度必须至少为8位字符', en: 'Password must be at least 8 characters long' },
  maxFourRepeated: { zh: '密码不能包含超过4位相同的相邻字符', en: 'Password cannot contain more than 4 consecutive characters' },
  cancel: { zh: '取消', en: 'Cancel' },
  confirm: { zh: '确定', en: 'Confirm' },
  closeAll: { zh: '关闭所有', en: 'Close all' },
  closeOthers: { zh: '关闭其他', en: 'Close others' },
  fullscreen: { zh: '全屏', en: 'Fullscreen' },
  exitFullscreen: { zh: '退出全屏', en: 'Exit fullscreen' },
  robotOffline: { zh: '机器人离线', en: 'Robot offline' },
  robotOnline: { zh: '机器人在线', en: 'Robot online' },
  robotStatus: { zh: '机器人状态', en: 'Robot status' },
  selectFile: { zh: '选择文件', en: 'Select file' },
  uploadImage: { zh: '上传图片', en: 'Upload image' },
  networkDebugInfo: { zh: '网络调试信息', en: 'Network debug info' },
  networkInfo: { zh: '网络信息', en: 'Network info' },
  networkInterface: { zh: '网络接口名称', en: 'Network interface' },
  ipAddress: { zh: 'IPv4地址', en: 'IPv4 address' },
  macAddress: { zh: 'MAC地址', en: 'MAC address' },
  debugInfo: { zh: '调试信息', en: 'Debug info' },
  quickSearch: { zh: '快速搜索定位', en: 'Quick search' },
  fenceManage: { zh: '电子围栏管理', en: 'Electronic fence management' },
  add: { zh: '添加', en: 'Add' },
  insert: { zh: '插入', en: 'Insert' },
  cancelEdit: { zh: '取消编辑', en: 'Cancel edit' },
  editArea: { zh: '编辑区域', en: 'Edit area' },
  // 围栏切割相关词条
  fenceCutting: { zh: "围栏切割", en: "Fence cutting" },
  fenceTools: { zh: "围栏工具", en: "Fence tools" },
  // 围栏工具/合并预览新增文案（提示原因、合并预览保存）
  mergeModeActiveCannotCut: { zh: "合并模式中无法切割围栏", en: "Cannot cut fences while merge mode is active" },
  pleaseCancelMergePreviewFirst: { zh: "请先取消合并预览", en: "Please cancel merge preview first" },
  selectFenceToEdit: { zh: "请选择一个围栏进行编辑", en: "Please select a fence to edit" },
  selectTwoCutPoints: { zh: "请选择两个围栏顶点进行切割", en: "Please select two fence vertices to cut" },
  executeCut: { zh: "执行切割", en: "Execute cut" },
  cancelCut: { zh: "取消切割", en: "Cancel cut" },
  fenceMerging: { zh: "围栏合并", en: "Fence merge" },
  selectFencesToMerge: { zh: "点击围栏进行多选，最后确定合并", en: "Click fences to multi-select, then confirm merge" },
  confirmMerge: { zh: "确定合并", en: "Confirm merge" },
  mergePreviewReady: { zh: "合并预览已生成", en: "Merge preview generated" },
  cancelMergePreview: { zh: "取消合并预览", en: "Cancel merge preview" },
  newFenceName: { zh: "新围栏名称", en: "New fence name" },
  mergeSaveSuccess: { zh: "围栏合并保存成功", en: "Merged fence saved successfully" },
  mergeSaveFailed: { zh: "围栏合并保存失败", en: "Failed to save merged fence" },
  pleaseEnterEditModeForMerge: { zh: "请先进入编辑模式再进行合并", en: "Please enter edit mode before merging" },
  cutModeActiveCannotMerge: { zh: "切割模式中无法合并围栏", en: "Cannot merge while cutting mode is active" },
  pleaseSelectAtLeastTwoFencesToMerge: { zh: "请至少选择两个围栏进行合并", en: "Select at least two fences to merge" },
  mergeFailedInvalidFences: { zh: "选中的围栏数据无效，无法合并", en: "Selected fences are invalid, cannot merge" },
  mergeFailed: { zh: "围栏合并失败", en: "Fence merge failed" },
  mergeProducedMultiplePolygons: { zh: "合并结果包含多个区域，已取最大区域生成预览", en: "Merge produced multiple areas; used the largest one" },
  mergeRequireSameStation: { zh: "只能合并同一基站的围栏", en: "Only fences from the same station can be merged" },
  mergeRequireSameType: { zh: "只能合并同类型围栏", en: "Only fences of the same type can be merged" },
  mergeRequireSamePriority: { zh: "只能合并同优先级围栏", en: "Only fences with the same priority can be merged" },
  mergeRequireConnected: { zh: "围栏不相邻或不连通，无法合并", en: "Fences are not adjacent/connected, cannot merge" },
  editingFence: { zh: "正在编辑围栏", en: "Editing fence" },
  adjacentPointsCantCut: { zh: "选择的两点相邻，无法切割", en: "Selected points are adjacent, cannot cut" },
  invalidPolygonAfterCut: { zh: "切割后的多边形无效，请选择其他点", en: "Invalid polygon after cutting, please select other points" },
  cutSuccess: { zh: "围栏切割成功", en: "Fence cutting successful" },
  cutFailed: { zh: "围栏切割失败", en: "Fence cutting failed" },
  cutPointsNotEnough: { zh: "请选择两个点进行切割", en: "Please select two points to cut" },
  invalidFenceData: { zh: "无效的围栏数据", en: "Invalid fence data" },
  sameLayerConflict: { zh: "同优先级围栏之间不能冲突，请重新操作", en: "Fences with the same priority cannot conflict, please try again" },
  priorityChanged: { zh: "优先级已调整为有效范围", en: "Priority has been adjusted to valid range" },
  priorityUnchanged: { zh: "优先级未发生变化", en: "Priority hasn't changed" },
  saveFailed: { zh: "保存失败，已恢复到原始形状", en: "Save failed, restored to original shape" },
  hasUnsavedChanges: { zh: "有未保存的更改", en: "Has unsaved changes" },
  saving: { zh: "保存中...", en: "Saving..." },
  saveSuccess: { zh: "保存成功", en: "Save successful" },
  pleaseFinishCurrentEdit: { zh: "请先完成当前围栏的编辑", en: "Please finish editing the current fence first" },
  hasUnsavedChangesConfirm: { zh: "有未保存的更改，确定要退出编辑模式吗？", en: "There are unsaved changes, are you sure you want to exit edit mode?" },
  fenceDragCompleted: { zh: "围栏拖拽完成", en: "Fence drag completed" },
  preview:{ zh: "预览", en: "Preview" },
  cancelPreview:{ zh: "取消预览", en: "Cancel preview" },
  unsaved: { zh: "未保存", en: "Unsaved" },
  remove: { zh: "移除", en: "Remove" },
  layerSort: { zh: "图层排序", en: "Layer sort" },
  apply: { zh: "应用", en: "Apply" },
  moveLayerToTop: { zh: "置顶", en: "Move to top" },
  moveLayerUp: { zh: "上移一层", en: "Move up" },
  moveLayerDown: { zh: "下移一层", en: "Move down" },
  moveLayerToBottom: { zh: "置底", en: "Move to bottom" },
  prioritySetting: { zh: "优先级设置", en: "Priority setting" },
  layerSortOperation: { zh: "图层排序操作", en: "Layer sort operation" },
  layerSortUpdateSuccess: { zh: "图层排序更新成功", en: "Layer sorting updated successfully" },
  currentStationLayers: { zh: "当前基站图层", en: "Current station layers" },
  layerSortUpdateFailed: { zh: "图层排序更新失败", en: "Layer sorting update failed" },
  layerAlreadyTop: { zh: "当前图层已经在最顶层", en: "Current layer is already on top" },
  layerAlreadyBottom: { zh: "当前图层已经在最底层", en: "Current layer is already at the bottom" },
  selectedTargetLayer: { zh: "选择了目标图层: {name}，可以调整优先级值后应用", en: "Selected target layer: {name}, you can apply after adjusting the priority" },
  restoreShapeError: { zh: "恢复图层形状时出错", en: "Error restoring layer shape" },
  invalidLayer: { zh: "无效的图层对象", en: "Invalid layer object" },
  invalidOriginalShape: { zh: "无效的原始形状数据", en: "Invalid original shape data" },
  notEnoughValidPoints: { zh: "原始形状中有效点不足，无法形成多边形", en: "Not enough valid points in original shape to form a polygon" },
  removeTipLayerError: { zh: "移除编辑提示层失败", en: "Failed to remove edit tip layer" },
  checkIntersectionError: { zh: "检查图层交叉出错", en: "Error checking layer intersection" },
  confirmMoveUpLayer: { zh: "确定要将当前图层上移一层吗？", en: "Confirm to move the current layer up one level?" },
  confirmMoveDownLayer: { zh: "确定要将当前图层下移一层吗？", en: "Confirm to move the current layer down one level?" },
  confirmMoveToTopLayer: { zh: "确定要将当前图层置于顶层吗？", en: "Confirm to move the current layer to the top?" },
  confirmMoveToBottomLayer: { zh: "确定要将当前图层置于底层吗？", en: "Confirm to move the current layer to the bottom?" },
  confirmSetLayerPriority: { zh: "确定要将当前图层优先级设置为 {priority} 吗？", en: "Confirm to set the current layer priority to {priority}?" },
  pleaseEnterEditMode: { zh: "请先进入编辑模式", en: "Please enter edit mode" },
  pleaseSelectFenceToCut: { zh: "请先选择一个围栏进行切割", en: "Please select a fence to cut" },
  confirmOperation: { zh: "确认操作", en: "Confirm Operation" },
  alreadySelectedTwoPoints: { zh: "已选择两个点，请点击切割按钮完成操作", en: "Already selected two points, please click the cut button to complete the operation" },
  pleaseSelectValidFence: { zh: "请先选择一个有效的围栏", en: "Please select a valid fence" },
  electronicFence: { zh: '电子围栏', en: 'Electronic fence' },
  pleaseClickEditAreaButton: { zh: "请先点击按钮【编辑区域】后操作", en: "Please click the button [Edit Area] before operating" },
  pleaseDrawFence: { zh: "当前围栏无数据,请绘制围栏", en: "The current fence has no data, please draw the fence" },
  name: { zh: '名称', en: 'Name' },
  inputName: { zh: '请输入名称', en: 'Please enter the name' },
  type: { zh: '类型', en: 'Type' },
  description: { zh: '描述', en: 'Description' },
  descInfo: { zh: '描述信息', en: 'Descriptive information' },
  jobDescInfo: { zh: '任务描述信息', en: 'Task description information' },
  area: { zh: '区域', en: 'Area' },
  isCollect: { zh: '是否采集', en: 'Whether to collect' },
  yes: { zh: '是', en: 'Yes' },
  no: { zh: '否', en: 'No' },
  supportFiles: { zh: '支持.json文件', en: 'Support .json files' },
  collectData: { zh: '采集数据', en: 'Collected data' },
  copyExample:{ zh : '复制示例数据',en : 'Copy the sample data' },
  save: { zh: '保存', en: 'Save' },
  operation: { zh: '操作', en: 'Operation' },
  edit: { zh: '编辑', en: 'Edit' },
  systemTip: { zh: '系统提示', en: 'System tip' },
  confirmDelete: { zh: '确认删除?', en: 'Confirm delete?' },
  draw: { zh: '绘制', en: 'Draw' },
  cancelDrawSuccess: { zh: '已取消绘制', en: 'Drawing cancelled' },
  stationRequired: { zh: "归属点不能为空", en: "The affiliated station cannot be empty" },
  collectDataRequired: { zh: "采集数据不可为空", en: "The collected data cannot be empty" },
  jsonFormatError: { zh: "不符合json格式", en: "It does not conform to the JSON format" },
  nameRequired: { zh: "名称不能为空", en: "The name cannot be empty" },
  electronicFenceLackingMapAreaSetting: { zh: "电子围栏未完成地图区域设置", en: "The electronic fence has not completed the map area setting." },
  avoidFenceConflict: { zh: "围栏之间不能冲突，请重新操作", en: "There should be no conflict between the fences. Please operate again." },
  jobManagement: { zh: '作业管理', en: 'Job management' },
  status: { zh: '状态', en: 'Status' },
  belongStation: { zh: '归属站点', en: 'Belonging station' },
  search: { zh: '查询', en: 'Search' },
  jobInfo: { zh: '作业信息', en: 'Homework information' },
  taskType: { zh: '类型', en: 'Type' },
  createTime: { zh: '创建时间', en: 'Create time' },
  messageTime:{ zh: '消息时间',en:'Message time'},
  updateTime: { zh: '修改时间', en: 'Update time' },
  noModify: { zh: '暂无修改', en: 'Not modified' },
  modify: { zh: '修改', en: 'Modify' },
  enable: { zh: '启用', en: 'Enable' },
  pathPlanning: { zh: '路径规划', en: 'Path planning' },
  importPath: { zh: '导入路径', en: 'Import path' },
  fileImport: { zh: '文件导入', en: 'File import' },
  collectionData: { zh: '采集数据', en: 'Collection data' },
  collectionDataRequired: { zh: '采集数据不可少于3个节点', en: 'Collection data cannot be less than 3 nodes' },
  generateAreaFromCollectPoints: { zh: '根据采集数据生成采集区域', en: 'Generate area from collection data' },
  expandDistance: { zh: '扩展距离(米)', en: 'Expand distance (m)' },
  cornerStyle: { zh: '拐角样式', en: 'Corner style' },
  cornerRound: { zh: '圆弧', en: 'Round' },
  cornerMiter: { zh: '直角', en: 'Miter' },
  bufferResolution: { zh: '圆角精度', en: 'Roundness detail' },
  generateArea: { zh: '生成区域', en: 'Generate area' },
  invalidExpandDistance: { zh: '扩展距离必须大于0', en: 'Expand distance must be greater than 0' },
  generateAreaFailed: { zh: '生成区域失败', en: 'Failed to generate area' },
  layerPriority: { zh: '优先级', en: 'Priority' },
  layerPriorityRequired: { zh: '优先级不能为空', en: 'Priority cannot be empty' },
  tips: { zh: '提示', en: 'Tips' },
  importTip1: { zh: '1.导入数据为json格式', en: '1.Import data should be in JSON format' },
  importTip2: { zh: '2.坐标系统支持WGS84', en: '2.Coordinate system supports WGS84' },
  importTip3: { zh: '3.mode:0-普通点,1-起点,2-终点', en: '3.mode:0-Normal point,1-Start point,2-End point' },
  importTip4: { zh: '4.type:0-普通点,1-站点', en: '4.type:0-Normal point,1-Station' },
  confirmEnable: { zh: '确认启用此任务吗?', en: 'Confirm enable?' },
  taskDescription: { zh: '请输入任务描述', en: 'Please input task description' },
  typeRequired: { zh: '类型不能为空', en: 'Type cannot be empty' },
  dataRequired: { zh: '数据不能为空', en: 'Data cannot be empty' },
  loading: { zh: '加载中', en: 'Loading' },
  fenceRecalcRendering: { zh: '图层正在重新计算渲染中....', en: 'Recalculating and rendering current layer...' },
  collectDataRendering: { zh: '正在渲染采集数据....', en: 'Rendering collection data...' },
  addNode: { zh: '添加节点', en: 'Add node' },
  taskNode: { zh: '任务节点', en: 'Task node' },
  jobNode: { zh: '作业节点', en: 'Homework node' },
  mark: { zh: '标记', en: 'Mark' },
  noNodes: { zh: '当前任务没有设置节点', en: 'The current task has no nodes set.' },
  noCoordinates: { zh: '节点未完成设置坐标位置', en: 'The node has not completed the setting of the coordinate position' },
  taskManage: { zh: '任务管理', en: 'Task management' },
  taskInfo: { zh: '任务信息', en: 'Task information' },
  inputType: { zh: '请输入类型', en: 'Please input type' },
  disable: { zh: '禁用', en: 'Disable' },
  confirmDisable: { zh: '确认禁用此任务吗?', en: 'Confirm disable the task?' },
  step1: { zh: '第一步', en: 'Step 1' },
  step2: { zh: '第二步', en: 'Step 2' },
  step3: { zh: '第三步', en: 'Step 3' },
  baseInfoMaintain: { zh: '基本信息维护', en: 'Basic info maintenance' },
  selectTaskJob: { zh: '选择任务作业', en: 'Select task job' },
  workInstructionMaintain: { zh: '工作指令维护', en: 'Work instruction maintenance' },
  selectJob: { zh: '选择作业', en: 'Select job' },
  cycles: { zh: '圈数', en: 'Number of laps' },
  cyclesTip:{ zh:'只能输入正整数且大于0', en: 'Only positive integers greater than 0 can be input'},
  jobName: { zh: '作业名称', en: 'Job name' },
  jobAddLimitOnce:{ zh: '作业只能添加一次', en: 'Homework can only be added once'},
  jobType: { zh: '作业类型', en: 'Homework type' },
  addTrigger: { zh: '添加触发器', en: 'Add trigger' },
  addAction: { zh: '添加动作', en: 'Add actions' },
  finish: { zh: '完成', en: 'Finish' },
  next: { zh: '下一步', en: 'Next step' },
  prev: { zh: '上一步', en: 'Previous step' },
  trigger: { zh: '触发器', en: 'Trigger' },
  triggerName: { zh: '触发器名称', en: 'Trigger name' },
  triggerType: { zh: '触发器类型', en: 'Trigger type' },
  pathNode: { zh: '路径节点', en: 'Path no de' },
  latLng: { zh: '经纬度', en: 'LatLng' },
  guide: { zh: '指导', en: 'Guide' },
  inputLatitude: { zh: '请输入经度', en: 'Please input latitude' },
  inputLongitude: { zh: '请输入纬度', en: 'Please input longitude' },
  inputTop: { zh: '请输入top', en: 'Please input top' },
  inputLeft: { zh: '请输入left', en: 'Please input left' },
  inputRight: { zh: '请输入right', en: 'Please input right' },
  inputBottom: { zh: '请输入bottom', en: 'Please input bottom' },
  inputTimestamp: { zh: '请输入时间戳', en: 'Please input timestamp' },
  PleaseInputTime: { zh: '请输入时间', en:'Please enter the time'},
  PleaseInputMax: { zh: '请输入大于0的时间', en:'Please enter a time greater than 0'},
  action: { zh: '动作', en: 'Action' },
  actionName: { zh: '动作名称', en: 'Action name' },
  actionType: { zh: '动作类型', en: 'Action type' },
  patrolData: { zh: '巡逻数据', en: 'Patrol data' },
  speakerData: { zh: '喊话数据', en: 'Speaker data' },
  inputRounds: { zh: '请输入圈数', en: 'Please enter the number of laps' },
  on: { zh: '开', en: 'On' },
  off: { zh: '关', en: 'Off' },
  streaming: { zh: '流媒体', en: 'Streaming media' },
  local: { zh: '本地语音', en: 'Local voice' },
  inputSoundUrl: { zh: '请输入声音地址', en: 'Please input sound URL' },
  inputVoiceId: { zh: '请输入音频文件ID', en: 'Please input audio ID' },
  inputPlayTimes: { zh: '请输入播放次数', en: 'Please enter the number of plays' },
  inputPlayInterval: { zh: '请输入播放间隔', en: 'Please input play interval' },
  pathNodeRequired: { zh: '路径节点不能为空', en: 'Path node cannot be empty' },
  latLngRequired: { zh: '经纬度不能为空', en: 'LatLng cannot be empty' },
  guideDataRequired: { zh: '指导数据不能全为空', en: 'Guide data cannot be empty' },
  triggerNameRequired: { zh: '触发器名称不能为空', en: 'Trigger name cannot be empty' },
  triggerTypeRequired: { zh: '触发器类型不能为空', en: 'Trigger type cannot be empty' },
  actionNameRequired: { zh: '行动名称不能为空', en: 'Action name cannot be empty' },
  actionTypeRequired: { zh: '行动类型不能为空', en: 'Action type cannot be empty' },
  roundsRequired: { zh: '巡逻圈数不能为空', en: 'Rounds cannot be empty' },
  speakerDataRequired: { zh: '声音数据不能为空', en: 'Speaker data cannot be empty' },
  noJobsSelected: { zh: '你未选择任何作业！', en: 'No jobs selected!' },
  taskScheduleTable: { zh: '任务调度表', en: 'Task schedule table' },
  task: { zh: '任务', en: 'Task' },
  priority: { zh: '优先级', en: 'Priority' },
  executionMethod: { zh: '执行方式', en: 'Execution method' },
  executionTimes: { zh: '执行次数', en: 'Execution times' },
  unlimited: { zh: '不限次', en: 'Unlimited' },
  limited: { zh: '限次', en: 'Limited' },
  times: { zh: '次', en: 'Times' },
  executionTime: { zh: '执行时间', en: 'Execution time' },
  selectDate: { zh: '选择日期', en: 'Select date' },
  selectTime: { zh: '选择时间', en: 'Select time' },
  selectTimeRange: { zh: '选择时间段', en: 'Select time range' },
  monday: { zh: '周一', en: 'Monday' },
  tuesday: { zh: '周二', en: 'Tuesday' },
  wednesday: { zh: '周三', en: 'Wednesday' },
  thursday: { zh: '周四', en: 'Thursday' },
  friday: { zh: '周五', en: 'Friday' },
  saturday: { zh: '周六', en: 'Saturday' },
  sunday: { zh: '周日', en: 'Sunday' },
  robotDesc: { zh: '机器人描述信息', en: 'Robot description' },
  robotNote: { zh: '注', en: 'Note' },
  robotNoteDesc1: { zh: '机器人为非必选。', en: 'Robot is optional.' },
  robotNoteDesc2: { zh: '如果不选择机器人，则调度此任务所在的站点下属机器人执行。', en: 'If no robot is selected, the task will be executed by robots under the station where this task belongs.' },
  robotNoteDesc3: { zh: '如果选择了机器人，则调度此任务时只能由此机器人执行。', en: 'If a robot is selected, this task can only be executed by this robot when scheduled.' },
  taskName: { zh: '任务名称', en: 'Task name' },
  robotName: { zh: '机器名称', en: 'Robot name' },
  serialNumber: { zh: '序列号', en: 'Serial number' },
  taskSchedule: { zh: '任务调度', en: 'Task scheduling' },
  systemTips: { zh: '系统提示', en: 'System tips' },
  confirmDeleteTaskInfo: { zh: '确定删除此任务信息', en: 'Confirm delete this task info?' },
  promptFromSystem: { zh: '来自系统的提示', en: 'Prompt from system' },
  robotRequiredForImmediate: { zh: '立即执行时需要选择机器人', en: 'You need to select a robot when executing immediately' },
  operationSuccess: { zh: '操作成功', en: 'Operation successful' },
  confirmChangeScheduleStatus: { zh: '是否修改任务调度状态', en: 'Whether to modify the task scheduling status?' },
  noModification: { zh: '暂无修改', en: 'No modification' },
  taskCannotBeEmpty: { zh: '任务不能为空', en: 'Task cannot be empty' },
  executionMethodCannotBeEmpty: { zh: '执行方式不能为空', en: 'Execution method cannot be empty' },
  startDayCannotBeEmpty: { zh: '请输入开始日期', en: 'Please enter start date' },
  endDayCannotBeEmpty: { zh: '请输入结束日期', en: 'Please enter end date' },
  startDayCannotGreaterThanEndDay: { zh: '开始日期不能晚于结束日期', en: 'Start date cannot be later than end date' },
  timeCannotBeEmpty: { zh: '时间不能为空', en: 'Time cannot be empty' },
  executionTimesCannotBeEmpty: { zh: '执行次数不能为空', en: 'The number of executions cannot be empty' },
  execute:{zh:"执行",en:"Execute"},
  everyYear: { zh: "每年：", en: "Every year: " },
  everyMonth: { zh: "每月：", en: "Every month: " },
  to: { zh: "至", en: "to" },
  month: { zh: "月", en: "month" },
  day: { zh: "日", en: "day" },
  dateCannotBeEmpty: { zh: "日期不能为空", en: "The date cannot be empty" },
  weekCannotBeEmpty: { zh: "请在时间上方至少选择一天", en: "Please select at least one day above the time" },
  startMonthCannotBeEmpty: { zh: "每年的开始月份不能为空", en: "The start month cannot be empty" },
  endMonthCannotBeEmpty: { zh: "每年的结束月份不能为空", en: "The end month cannot be empty" },
  startMonthCannotGreaterThanEndMonth: { zh: "开始月份不能大于结束月份", en: "The start month cannot be greater than the end month" },
  startAndEndTimeCannotBeTheSame: { zh: "开始时间和结束时间不能一致", en: "Start time and end time cannot be the same" },
  timeCannotBeEarlierThanCurrent: { zh: "所选时间不能早于当前时间", en: "Selected time cannot be earlier than current time" },
  startAndEndDayCannotBeTheSame: { zh: "每个月的开始日期和结束日期不能相同", en: "The start date and end date of each month cannot be the same" },
  startAndEndMonthCannotBeTheSame: { zh: "每年的开始月份和结束月份不能相同", en: "The starting month and the ending month of each year cannot be the same" },
  to: { zh: "至", en: "To" },
  everyWeek: { zh: "每周", en: "Every week" },
  sun:{zh:"日",en:"Sun"},
  mon:{zh:"一",en:"Mon"},
  tues: { zh: '二', en: 'Tues' },
  wednes: { zh: '三', en: 'Wednes' },
  thurs: { zh: '四', en: 'Thurs' },
  fri: { zh: '五', en: 'Fri' },
  satur: { zh: '六', en: 'Satur' },
  timesNumber: { zh: '次数', en: 'TimesNumber' },
  back:{zh:"返回",en:"Back"},
  taskExecution: { zh: "任务执行", en: "Task execution" },
  confirmStopTask: { zh: "确定终止此执行中的任务", en: "Confirm to stop this running task" },
  stop: { zh: "终止", en: "Stop" },
  playback: { zh: "回放", en: "Playback" },
  robot: { zh: "机器人", en: "Robot" },
  executionCount: { zh: "执行次数", en: "Exec count" },
  dispatchTime: { zh: "下发时间", en: "Dispatch time" },
  receiveTime: { zh: "接收时间", en: "Receive time" },
  completionTime: { zh: "完成时间", en: "Completion time" },
  dispatchData: { zh: "下发数据", en: "Dispatch data" },
  feedbackData: { zh: "反馈数据", en: "Feedback data" },
  version: { zh: "版本", en: "Version" },
  warningTime: { zh: "预警时间", en: "Warning time" },
  warningMessage: { zh: "预警信息", en: "Warning message" },
  high: { zh: "高", en: "High" },
  medium: { zh: "中", en: "Medium" },
  low: { zh: "低", en: "Low" },
  totalDuration: { zh: "总时长", en: "Total duration" },
  playbackSpeed: { zh: "倍速", en: "Speed" },
  play: { zh: "播放", en: "Play" },
  pause: { zh: "暂停", en: "Pause" },
  progress: { zh: "进度", en: "Progress" },
  secondaryWarning:{zh:"二级预警",en:"Level 2 warning"},
  primaryWarning:{zh:"一级预警",en:"Level 1 warning"},
  robotControl: { zh: "机器人控制", en: "Robot control" },
  unknown: { zh: "未知", en: "Unknown" },
  productId: { zh: "产品ID", en: "Product id" },
  modelNumber: { zh: "型号", en: "Model number" },
  versionInfo: { zh: "版本信息", en: "Version info" },
  powerOperation: { zh: "开关机操作", en: "Power operation" },
  lightControl: { zh: "灯光控制", en: "Light control" },
  fireNetGun: { zh: "发射网枪", en: "Fire net gun" },
  left: { zh: "左", en: "Left" },
  right: { zh: "右", en: "Right" },
  recover:{zh:"恢复",en:"Recover"},
  tripwire:{zh:"绊马索",en:"Tripwire"},
  leftFront:{zh:"左前",en:"Left front"},
  rightRear:{zh:"右后",en:"Right rear"},
  alarmControl: { zh: "警号", en: "Alarm" },
  videoControl: { zh: "视频", en: "Video" },
  magnetControl: { zh: "磁铁", en: "Magnet" },
  rectangularTask: { zh: "矩形任务", en: "Rectangular task" },
  speaker: { zh: "扬声器", en: "Speaker" },
  confirmSpeakerOn: { zh: "确定要开启扬声器吗？", en: "Confirm to turn on the speaker?" },
  confirmSpeakerOff: { zh: "确定要关闭扬声器吗？", en: "Confirm to turn off the speaker?" },
  terminate: { zh: "终止", en: "Terminate" },
  mcuVersion: { zh: "MCU固件版本号", en: "MCU firmware version" },
  systemVersion: { zh: "系统版本号", en: "System version" },
  powerModuleVersion: { zh: "动力模块版本号", en: "Power module version" },
  controlModuleVersion: { zh: "控制模块版本号", en: "Control module version" },
  navigationModuleVersion: { zh: "导航模块版本号", en: "Navigation module version" },
  perceptionModuleVersion: { zh: "感知模块版本号", en: "Perception module version" },
  communicationModuleVersion: { zh: "通信模块版本号", en: "Communication module version" },
  voiceFileVersion: { zh: "声音文件版本号", en: "Voice file version" },
  workAreaVersion: { zh: "活动范围版本号", en: "Work area version" },
  noVersionData: { zh: "当前设备未获取到版本数据", en: "No version data available for current device" },
  confirmPowerOn: { zh: "确定要操作此设备开机嘛", en: "Confirm to power on this device?" },
  confirmLightOn: { zh: "确定要操作此设备开灯?", en: "Confirm to turn on the light for this device?" },
  confirmLightOff: { zh: "确定要操作此设备关灯?", en: "Confirm to turn off the light for this device?" },
  confirmFireLeftNetGun: { zh: "确定要操作此设备左前方发射网枪吗？", en: "Confirm to fire net gun on the left front side of this device?" },
  confirmFireRightNetGun: { zh: "确定要操作此设备右后方发射网枪吗？", en: "Confirm to fire net gun on the right rear side of this device?" },
  confirmTripwireLeftFront: { zh: "确定要操作此设备左前方发射绊马索吗？", en: "Confirm to fire tripwire on the left front side of this device?" },
  confirmTripwireRightRear: { zh: "确定要操作此设备右后方发射绊马索吗？", en: "Confirm to fire tripwire on the right rear side of this device?" },
  confirmPause: { zh: "确定要操作此设备暂停任务？", en: "Confirm to pause this device?" },
  confirmResume: { zh: "确定要操作此设备恢复任务？", en: "Confirm to resume this device?" },
  robotList: { zh: "机器人列表", en: "Robot list" },
  serialNumberLabel: { zh: "序列号", en: "Serial number" },
  viewKeyPair: { zh: "查看密钥对", en: "View key pair" },
  generateKeyPair: { zh: "生成密钥对", en: "Generate key pair" },
  deviceParams: { zh: "设备参数", en: "Device parameters" },
  publicKey: { zh: "公钥", en: "Public key" },
  privateKey: { zh: "私钥", en: "Private key" },
  keyInfo: { zh: "密钥信息", en: "Key information" },
  confirmDeleteRobot: { zh: "确定删除此机器人信息", en: "Confirm delete this robot information" },
  confirmGenerateKey: { zh: "确定生成此机器人密钥对", en: "Confirm generate key pair for this robot" },
  pleaseInputProductId: { zh: "请输入产品ID", en: "Please input product id" },
  pleaseInputSerialNumber: { zh: "请输入序列号", en: "Please input serial number" },
  pleaseInputName: { zh: "请输入名称", en: "Please input name" },
  productIdRequired: { zh: "产品ID不能为空", en: "Product id cannot be empty" },
  serialNumberRequired: { zh: "序列号不能为空", en: "Serial number cannot be empty" },
  robotInfo:{zh:"机器人信息",en:"Robot info"},
  workOrderList: { zh: "工单列表", en: "Work order list" },
  workOrderNumber: { zh: "工单号", en: "Work order no." },
  workOrderStatus: { zh: "工单状态", en: "Work order status" },
  maintenanceWorkOrder: { zh: "维修保养工单", en: "Maintenance work order" },
  workOrderType: { zh: "工单类型", en: "Work order type" },
  faultTime: { zh: "故障时间", en: "Fault time" },
  equipmentStatus: { zh: "设备状态", en: "Equipment status" },
  urgencyLevel: { zh: "紧急程度", en: "Urgency level" },
  deadline: { zh: "截止时间", en: "Deadline" },
  maintenancePersonnel: { zh: "维保人员", en: "Maintenance personnel" },
  workOrderDescription: { zh: "工单描述", en: "Work order description" },
  maintenanceDetails: { zh: "维保明细", en: "Maintenance details" },
  addDetails: { zh: "添加明细", en: "Add details" },
  maintenanceItem: { zh: "维修明细项", en: "Maintenance item" },
  moduleName: { zh: "模块名称", en: "Module name" },
  maintenanceType: { zh: "维修类型", en: "Maintenance type" },
  maintenanceQuantity: { zh: "维保数量", en: "Maintenance quantity" },
  maintenanceAmount: { zh: "维保金额", en: "Maintenance amount" },
  remarks: { zh: "备注", en: "Remarks" },
  repair: { zh: "维修", en: "Repair" },
  maintenance: { zh: "保养", en: "Maintenance" },
  stopForRepair: { zh: "停机待维修", en: "Stopped for repair" },
  normalOperation: { zh: "正常运行", en: "Normal operation" },
  draft: { zh: "草稿", en: "Draft" },
  pending: { zh: "待处理", en: "Pending" },
  processing: { zh: "正在处理", en: "Processing" },
  processed: { zh: "已处理", en: "Processed" },
  replace: { zh: "更换", en: "Replace" },
  push: { zh: "推送", en: "Push" },
  confirmPushWorkOrder: { zh: "确定推送此工单信息", en: "Confirm to push this work order" },
  confirmProcessWorkOrder: { zh: "确定处理此工单信息", en: "Confirm to process this work order" },
  confirmFinishWorkOrder: { zh: "确定此工单已完成？(完成工单请在修改中维护维修明细项信息)", en: "Confirm this work order is completed? (Please maintain maintenance details in modification)" },
  happenTime:{zh:"发生时间",en:"Happen time"},
  view:{zh:"查看",en:"View"},
  quantity:{zh:"数量",en:"Quantity"},
  amount:{zh:"金额",en:"Amount"},
  confirmDeleteItem: { zh: "确定删除项信息", en: "Confirm the information of the item to be deleted" },
  shutdownPending: { zh: "停机待维修", en: "Shutdown pending maintenance" },
  moduleNameRequired: { zh: "模块名称不能为空", en: "The module name cannot be empty" },
  moduleNameMaxLength: { zh: "模块名称不可超过30个字", en: "The module name cannot exceed 30 characters" },
  enterValidNumber: { zh: "请输入正确数字", en: "Please enter a valid number" },
  enterValidAmount: { zh: "请输入正确维保金额", en: "Please enter a valid maintenance amount" },
  remarkMaxLength: { zh: "备注信息不可超过500个字", en: "The remark information cannot exceed 500 characters" },
  robotRequired: { zh: "机器人信息不可为空", en: "The robot information cannot be empty" },
  urgentLevelRequired: { zh: "紧急程度不可为空", en: "The urgent level cannot be empty" },
  descriptionRequired: { zh: "故障/保养描述不能为空", en: "The description of the malfunction/maintenance cannot be empty" },
  descriptionMinLength: { zh: "描述信息不可少于20个字", en: "The description information cannot be less than 20 characters" },
  descriptionMaxLength: { zh: "描述信息不可超过500个字", en: "The description information cannot exceed 500 characters" },
  deadlineRequired: { zh: "工单截止时间不能为空", en: "The deadline of the work order cannot be empty" },
  maintenanceTypeRequired: { zh: "维保类型不可为空", en: "The maintenance type cannot be empty" },
  workOrderTypeRequired: { zh: "工单类型不可为空", en: "The work order type cannot be empty" },
  userList: { zh: "用户列表", en: "User list" },
  keyword: { zh: "关键词", en: "Keyword" },
  phoneNumber: { zh: "手机号", en: "Phone number" },
  userRole: { zh: "用户角色", en: "User role" },
  noRole: { zh: "未给予角色", en: "No role assigned" },
  robotUserChange: { zh: "用户机器人变更", en: "User robot change" },
  robotListForUser: { zh: "的机器人列表", en: "'s Robot list" },
  stationManagement: { zh: "停靠点管理", en: "Station management" },
  pleaseInputStationName: { zh: "请输入站点名称", en: "Please input station name" },
  stationName: { zh: "站点名称", en: "Station name" },
  reset: { zh: "重置", en: "Reset" },
  addNewStation: { zh: "新增停靠点", en: "Add new station" },
  editStation: { zh: "编辑停靠点", en: "Edit station" },
  drawAndSave: { zh: "绘制后保存", en: "Draw and save" },
  deleteSuccess: { zh: "删除成功", en: "Delete successful" },
  saveSuccess: { zh: "保存成功", en: "Save successful" },
  confirmDeleteStation: { zh: "确定删除此节点", en: "Confirm delete this station" },
  loginLog: { zh: "登录日志", en: "Login log" },
  logDescription: { zh: "日志描述", en: "Log description" },
  operator: { zh: "操作人", en: "Operator" },
  operatorRole: { zh: "操作角色", en: "Operator role" },
  download: { zh: "下载", en: "Download" },
  groupId: { zh: "分组ID", en: "Group id" },
  operatorRoleName: { zh: "操作人角色", en: "Oper role" },
  operationLog: { zh: "操作日志", en: "Operation log" },
  logLevel: { zh: "日志级别", en: "Log level" },
  level: { zh: "级别", en: "Level" },
  parameters: { zh: "参数", en: "Parameters" },
  duration: { zh: "用时(ms)", en: "times(ms)" },
  result: { zh: "结果", en: "Result" },
  configManagement: { zh: "配置管理", en: "Configuration management" },
  uniqueIdentifier: { zh: "唯一标识", en: "Unique identifier" },
  pleaseInputUniqueId: { zh: "请输入唯一标识", en: "Please input unique identifier" },
  deleteMenuConfirm: { zh: "是否删除菜单", en: "Confirm delete menu?" },
  pleaseInputValue: { zh: "请输入值", en: "Please input value" },
  configInfo: { zh: "配置信息", en: "Configuration info" },
  configValueJsonPlaceholderSuffix: { zh: "（支持JSON格式）", en: " (JSON format supported)" },
  configValueJsonTip: { zh: "支持输入JSON格式的配置参数，系统会自动验证格式", en: "Supports JSON configuration parameters; the system validates the format automatically" },
  configValueInputFirst: { zh: "请先输入配置值", en: "Please enter configuration value first" },
  configJsonFormatSuccess: { zh: "JSON格式化成功", en: "JSON formatted successfully" },
  configJsonFormatInvalid: { zh: "JSON格式不正确，无法格式化", en: "Invalid JSON format, cannot format" },
  configContentNotJson: { zh: "当前内容不是JSON格式", en: "Current content is not in JSON format" },
  configValueJsonInvalid: { zh: "配置值JSON格式不正确，请检查语法", en: "Configuration value has invalid JSON syntax" },
  value: { zh: "值", en: "Value" },
  creator: { zh: "创建人", en: "Creator" },
  serviceList: { zh: "服务列表", en: "Service list" },
  normal: { zh: "正常", en: "Normal" },
  abnormal: { zh: "异常", en: "Abnormal" },
  belongService: { zh: "所属服务", en: "Belong service" },
  cluster: { zh: "集群", en: "Cluster" },
  instance: { zh: "实例", en: "Instance" },
  serviceName: { zh: "服务名", en: "Service name" },
  port: { zh: "端口", en: "Port" },
  weight: { zh: "权重", en: "Weight" },
  healthStatus: { zh: "健康状态", en: "Health status" },
  isEnabled: { zh: "是否启用", en: "Whether to enable" },
  temporaryInstance: { zh: "临时实例", en: "Temporary instance" },
  roleManagement: { zh: "角色管理", en: "Role management" },
  addRole: { zh: "添加角色", en: "Add role" },
  roleName: { zh: "角色名称", en: "Role name" },
  roleCode: { zh: "角色编码", en: "Role code" },
  submit: { zh: "提交", en: "Submit" },
  assignMenu: { zh: "赋值菜单", en: "Assign menu" },
  assignResource: { zh: "赋值资源", en: "Assign resource" },
  route: { zh: "路由", en: "Routing" },
  method: { zh: "方法", en: "Method" },
  pleaseEnterRoleName: { zh: "请输入角色名称", en: "Please enter role name" },
  roleNameFormatError: { zh: "角色名称格式不正确", en: "Invalid role name format" },
  pleaseEnterRoleCode: { zh: "请输入角色编码", en: "Please enter role code" },
  roleCodeFormatError: { zh: "角色编码格式不正确", en: "Invalid role code format" },
  remarkFormatError: { zh: "备注格式不正确", en: "Invalid remark format" },
  roleAssignMenu: { zh: "角色赋值菜单", en: "Role assign menu" },
  roleAssignResources: { zh: "角色赋值资源", en: "Role assign resources" },
  whether: { zh: "是否", en: "Whether" },
  roleDeleteConfirmation: { zh: "是否删除角色", en: "Whether to delete the role" },
  role: { zh: "角色", en: "Role" },
  resourceManagement: { zh: "资源管理", en: "Resource management" },
  all: { zh: "全部", en: "All" },
  disabled: { zh: "停用", en: "Disabled" },
  application: { zh: "应用", en: "Application" },
  userManagement: { zh: "用户管理", en: "User management" },
  backendUser: { zh: "后台用户", en: "Backend user" },
  addUser: { zh: "添加用户", en: "Add user" },
  account: { zh: "账号", en: "Account" },
  username: { zh: "用户名", en: "Username" },
  password: { zh: "密码", en: "Password" },
  giveUserRole: { zh: "给予用户角色", en: "Assign user role" },
  nickname: { zh: "昵称", en: "Nickname" },
  idNumber: { zh: "身份号", en: "Id number" },
  gender: { zh: "性别", en: "Gender" },
  male: { zh: "男", en: "Male" },
  female: { zh: "女", en: "Female" },
  birthday: { zh: "生日", en: "Birthday" },
  height: { zh: "身高", en: "Height" },
  age: { zh: "年龄", en: "Age" },
  years: { zh: "岁", en: "Years" },
  assignRole: { zh: "赋值角色", en: "Assign role" },
  none: { zh: "无", en: "None" },
  neverLoggedIn: { zh: "未登录过系统", en: "Never logged in" },
  userName: { zh: "用户姓名", en: "User name" },
  confirmModifyUserStatus: { zh: "是否修改用户状态", en: "Confirm modify user status?" },
  pleaseInputPhone: { zh: "请输入手机号", en: "Please input phone number" },
  phoneFormatError: { zh: "手机号格式错误", en: "Invalid phone number format" },
  phoneInputError: { zh: "手机号输入错误", en: "Phone number input error" },
  pleaseInputAccount: { zh: "请输入账号", en: "Please input account" },
  pleaseInputPassword: { zh: "请输入密码", en: "Please input password" },
  pleaseInputUsername: { zh: "请输入用户名", en: "Please input username" },
  userType: { zh: "用户类型", en: "User type" },
  heightError: { zh: "身高格式错误", en: "Invalid height format" },
  addMenu: { zh: "添加菜单", en: "Add menu" },
  hide: { zh: "隐藏", en: "Hide" },
  show: { zh: "显示", en: "Show" },
  path: { zh: "路径", en: "Path" },
  icon: { zh: "图标", en: "Icon" },
  sort: { zh: "排序", en: "Sort" },
  parentMenu: { zh: "父菜单", en: "Parent menu" },
  childMenu: { zh: "子菜单", en: "Child menu" },
  menuId: { zh: "菜单id", en: "Menu id" },
  menu: { zh: "菜单", en: "Menu" },
  whetherToChangeMenuState: { zh: "是否修改菜单状态", en: "Whether to change menu state" },
  isView: { zh: "是否显示", en: "Whether to display" },
  alarmHandlingRecord: { zh: "警情处置记录数据", en: "Alarm handling record data" },
  reportTime: { zh: "上报时间", en: "Report time" },
  selectDateAndTime: { zh: "选择日期和时间", en: "Select date and time" },
  dataDetailInfo: { zh: "数据详情信息", en: "Data detail information" },
  messageId: { zh: "信息ID", en: "Message id" },
  taskId: { zh: "任务ID", en: "Task id" },
  imageDetail: { zh: "图片详情", en: "Image detail" },
  operationRecordDetail: { zh: "操作下发记录详情", en: "Operation record detail" },
  operationRecord: { zh: "操作下发记录", en: "Operation record" },
  pleaseRecordFirst: { zh: "请先录音", en: "Please record the audio first" },
  allowMicrophone: { zh: "请先允许该网页使用麦克风", en: "Please allow microphone access first" },
  success: { zh: "成功", en: "Success" },
  publishTime: { zh: "下发时间", en: "Publish time" },
  publishType: { zh: "下发类型", en: "Publish type" },
  dataDetail: { zh: "数据明细", en: "Data detail" },
  dataInfo: { zh: "数据信息", en: "Data info" },
  startRecording: { zh: "开始录音", en: "Start recording" },
  pauseRecording: { zh: "暂停录音", en: "Pause recording" },
  playRecording: { zh: "播放录音", en: "Play recording" },
  stopPlaying: { zh: "停止播放", en: "Stop playing" },
  playWarning: { zh: "播放警告", en: "Play warn" },
  talkInspection: { zh: "对讲盘查", en: "Talk inspection" },
  trackAttack: { zh: "行为拒止", en: "Behavior prohibition" },
  trackAttackTitle: { zh: "行为拒止 - 目标选择", en: "Behavior prohibition - Target selection" },
  selectTargetLocation: { zh: "选择目标位置", en: "Select target location" },
  targetList: { zh: "目标列表", en: "Target list" },
  target: { zh: "目标", en: "Target" },
  position: { zh: "位置", en: "Position" },
  clickToSelectTarget: { zh: "点击选择目标", en: "Click to select target" },
  pleaseSelectTarget: { zh: "请选择目标", en: "Please select target" },
  confirmTrackAttack: { zh: "确认行为拒止", en: "Confirm behavior prohibition" },
  stopBehaviorProhibition: { zh: "停止行为拒止", en: "Stop behavior prohibition" },
  confirmStopBehaviorProhibition: { zh: "确定要停止行为拒止吗？", en: "Confirm to stop behavior prohibition?" },
  targetId: { zh: "目标ID", en: "Target id" },
  disposalComplete: { zh: "处置完成", en: "Disposal complete" },
  disposing: { zh: "处置中", en: "Disposing" },
  voice1: { zh: "语音1", en: "Voice 1" },
  voice2: { zh: "语音2", en: "Voice 2" },
  start: { zh: "开始", en: "Start" },
  end: { zh: "结束", en: "End" },
  send: { zh: "发送", en: "Send" },
  recordingDuration: { zh: "录音时长", en: "Recording duration" },
  confirmPlayWarning: { zh: "确定进行警告播放吗？", en: "Confirm to play warning?" },
  confirmTalkInspection: { zh: "确定进行喊话盘查吗？", en: "Confirm to start voice announcement inspection?" },
  confirmTrackTarget: { zh: "确定进行追踪目标吗？", en: "Confirm to track target?" },
  confirmIgnoreAlarm: { zh: "确定对此警情不做处置嘛？", en: "Confirm to ignore this alarm?" },
  confirmSendComplete: { zh: "确定要发送处置完成指令嘛？", en: "Confirm to send completion command?" },
  confirmSendDispose: { zh: "确定要发送处置指令嘛？", en: "Confirm to send disposal command?" },
  immediateResponse: { zh: "及时响应", en: "Immediate response" },
  asyncResponseCode: { zh: "异步响应码", en: "Async response code" },
  asyncResponseData: { zh: "异步响应数据", en: "Async response data" },
  asyncResponseMsg: { zh: "异步响应消息", en: "Async response msg" },
  asyncResponseTime: { zh: "异步响应时间", en: "Async response time" },
  operationTime: { zh: "操作时间", en: "Operation time" },
  operationType: { zh: "操作类型", en: "Operation type" },
  selectVoice: { zh: "请选择语音", en: "Please select voice" },
  voiceTalkOperation: { zh: "语音喊话操作", en: "Voice announcement operation" },
  pleaseSelectRobot: { zh: "请选择要查看数据的机器人", en: "Please select the robot to view the data" },
  netGunRecord: { zh: "网枪记录数据", en: "Net gun record data" },
  publishFailed: { zh: "下发失败", en: "Publish failed" },
  confirmRejectOperation: { zh: "确定要拒绝此操作嘛", en: "Confirm to reject this operation?" },
  confirmOpenNetGun: { zh: "确定要打开网枪嘛", en: "Confirm to open the net gun?" },
  dataDetails: { zh: "数据明细", en: "Data details" },
  alreadyAllowed: { zh: "已允许", en: "Already allowed" },
  alreadyRejected: { zh: "已拒绝", en: "Already rejected" },
  reject: { zh: "拒绝", en: "Reject" },
  allow: { zh: "允许", en: "Allow" },
  dataReportRecord: { zh: "数据上报记录", en: "Data report record" },
  dataType: { zh: "数据类型", en: "Data type" },
  dataTimestamp: { zh: "数据时间戳", en: "Data timestamp" },
  messageId: { zh: "消息Id", en: "Message id" },
  commandReplyRecord: { zh: "指令回复记录", en: "Command reply record" },
  dataProcessor: { zh: "数据处理器", en: "Data processor" },
  commandDispatchRecord: { zh: "指令下发记录", en: "Command dispatch record" },
  topic: { zh: "主题", en: "Topic" },
  publishTopic: { zh: "发布主题", en: "Publish topic" },
  sendObject: { zh: "发送对象", en: "Send object" },
  requestId: { zh: "请求Id", en: "Request id" },
  versionData: { zh: "版本数据", en: "Version data" },
  statusData: { zh: "状态数据", en: "Status data" },
  movementData: { zh: "移动数据", en: "Movement data" },
  warningData: { zh: "预警数据", en: "Early warning data" },
  versionHistoryData: { zh: "版本历史数据", en: "Version history data" },
  statusHistoryData: { zh: "状态历史数据", en: "Status history data" },
  movementHistoryData: { zh: "移动历史数据", en: "Movement history data" },
  warningHistoryData: { zh: "预警历史数据", en: "Early warning historical data" },
  mcuFirmwareVersion: { zh: "MCU固件版本号", en: "MCU firmware version" },
  systemVersion: { zh: "系统版本号", en: "System version" },
  powerModuleVersion: { zh: "动力模块版本号", en: "Power module version" },
  controlModuleVersion: { zh: "控制模块版本号", en: "Control module version" },
  navigationModuleVersion: { zh: "导航模块版本号", en: "Navigation module version" },
  perceptionModuleVersion: { zh: "感知模块版本号", en: "Perception module version" },
  communicationModuleVersion: { zh: "通信模块版本号", en: "Communication module version" },
  innerTemperature: { zh: "内部温度", en: "Inner temperature" },
  innerHumidity: { zh: "内部湿度", en: "Inner humidity" },
  outerTemperature: { zh: "外部温度（摄氏度）", en: "Outer Temperature (°C)" },
  windSpeed: { zh: "外部风速（m/s）", en: "Wind Speed (m/s)" },
  windDirection: { zh: "外部风向（°）", en: "Wind Direction (°)" },
  altitude: { zh: "海拔高度（m）", en: "Altitude (m)" },
  nominalPower: { zh: "标称电量", en: "Nominal electric quantity" },
  remainingPower: { zh: "剩余电量", en: "Remaining power" },
  axisAngle: { zh: "轴倾角", en: "Axis angle" },
  rotationSpeed: { zh: "转速", en: "Rotation speed" },
  gearRatio: { zh: "传动比", en: "Gear ratio" },
  networkType: { zh: "网络类型", en: "Network type" },
  networkStatus: { zh: "网络通信状态", en: "Network communication status" },
  upstreamRate: { zh: "上行速率（Mbps）", en: "Upstream Rate (Mbps)" },
  downstreamRate: { zh: "下行速率（Mbps）", en: "Downstream Rate (Mbps)" },
  nominalCapacity: { zh: "标称容量", en: "Nominal capacity" },
  remainingStorage: { zh: "剩余存储", en: "Remaining storage" },
  controlMode: { zh: "控制模式", en: "Control mode" },
  totalRunningTime: { zh: "自球启用后已累计运行时间", en: "Total running time since activation" },
  totalRunningDistance: { zh: "自球启用后已累计运行距离（m）", en: "Total running distance since activation (m)" },
  coordinateType: { zh: "坐标类型", en: "Coordinate type" },
  polarCoordinate: { zh: "极坐标", en: "Polar coordinate" },
  longitudeAngle: { zh: "经度/角度", en: "Longitude/angle" },
  latitudeDistance: { zh: "纬度/距离", en: "Latitude/distance" },
  gpsTime: { zh: "GPS时间", en: "GPS time" },
  directionInfo: { zh: "方向,正北为0，顺时针，精确到1位", en: "Direction, 0° is north, clockwise, 1 decimal place" },
  speed: { zh: "速度（m/s）", en: "Speed (m/s)" },
  acceleration: { zh: "加速度（m/s2）", en: "Acceleration (m/s²)" },
  pathId: { zh: "路径ID", en: "Path id" },
  currentTaskRunningTime: { zh: "本次任务已运行时间", en: "Current task running time" },
  currentTaskDistance: { zh: "本次任务已运行距离（m）", en: "Current task running distance (m)" },
  thirdPartyData: { zh: "三方数据", en: "Third party data" },
  warningLevel: { zh: "预警等级", en: "Warning level" },
  warningColor: { zh: "预警色", en: "Warning color" },
  red: { zh: "红色", en: "Red" },
  yellow: { zh: "黄色", en: "Yellow" },
  warningName: { zh: "预警名称", en: "Warning name" },
  engineSpeed: { zh: "引擎转速", en: "Engine speed" },
  availableStorage: { zh: "可用容量", en: "Available storage" },
  historyVideo: { zh: "历史视频", en: "History video" },
  videoTime: { zh: "视频时间", en: "Video time" },
  fileName: { zh: "文件名", en: "File name" },
  startTime: { zh: "起始时间", en: "Start time" },
  fileDuration: { zh: "文件大小 (kb)", en: "File size (kb)" },
  videoPlay: { zh: "视频播放", en: "Video play" },
  configNotFound: { zh: "未找到配置信息", en: "Configuration not found" },
  historyVideoUrlNotConfigured: { zh: "未配置历史视频播放地址", en: "History video playback URL not configured" },
  close: { zh: "关闭", en: "Close" },
  comprehensiveOverview: { zh: "综合概览", en: "Comprehensive overview" },
  workData: { zh: "工况数据", en: "Work data" },
  workVideo: { zh: "工况视频", en: "Work video" },
  robotIsOffline: { zh: "机器人已离线", en: "Robot is offline" },
  robotNotOnline: { zh: "机器人不在线", en: "Robot not online" },
  robotIsOnline: { zh: "机器人已上线", en: "Robot is online" },
  streamingAddrNotConfigured: { zh: "未配置实时视频播放地址", en: "The real-time video streaming address has not been configured" },
  warn: { zh: "警告", en: "Warn" },
  danger: { zh: "危险", en: "Danger" },
  siren1: { zh: "警笛1", en: "Siren 1" },
  siren2: { zh: "警笛2", en: "Siren 2" },
  confirmPlaySiren1: { zh: "确定播放警笛1嘛", en: "Confirm to play Siren 1?" },
  confirmPlaySiren2: { zh: "确定播放警笛2嘛", en: "Confirm to play Siren 2?" },
  selectSiren: { zh: "请选择警笛", en: "Please select siren" },
  voiceIntercomOperation: { zh: "语音喊话操作", en: "Voice announcement operation" },
  confirmTrackingAttack: { zh: "确定要进行追踪攻击嘛", en: "Confirm to initiate tracking attack?" },
  confirmCompleteDisposal: { zh: "确定完成处置嘛？", en: "Confirm to complete disposal?" },
  image: { zh: "图片", en: "image" },
  confirmIgnoreAlert: { zh: "确定要忽略此次警情嘛？", en: "Confirm to ignore this alert?" },
  confirmHandleAlert: { zh: "确定要处理此次警情嘛？", en: "Confirm to handle this alert?" },
  attack: { zh: "追踪攻击", en: "Track attacks" },
  sirenDrive: { zh: "警笛驱赶", en: "Siren drive" },
  doFinsh: { zh: "处理完成", en: "Processed" },
  voiceInteraction: { zh: "语音交互", en: "Voice interaction" },
  ignore: { zh: "忽略", en: "Ignore" },
  dispose: { zh: "处置", en: "Dispose" },
  handle: { zh: "处理", en: "Deal" },
  buffering: { zh: "正在缓冲...", en: "Buffering..." },
  netGunPermission: { zh: "网枪许可", en: "Net gun permission" },
  alarmDisposal: { zh: "警情处置", en: "Police incident handling" },
  trackTarget: { zh: "追踪目标", en: "Track target" },
  noDisposal: { zh: "不处置", en: "No disposal" },
  confirmTrackTargetMsg: { zh: "确定进行追踪目标吗？", en: "Confirm to track target?" },
  noPermissionPage: { zh: "Oh~~您没有浏览这个页面的权限~", en: "Oh~~You don't have permission to view this page~" },
  pageNotFound: { zh: "Oh~~您的页面好像飞走了~ ", en: "Oh~~Your page seems to have flown away~" },
  backHome: { zh: "返回首页", en: "Back home" },
  backPrev: { zh: "返回上一页", en: "Back previous page" },
  jdNotEmpty: { zh: "经度不能为空", en: "Longitude cannot be empty" },
  wdNotEmpty: { zh: "维度不能为空", en: "Latitude cannot be empty" },
  JSONFormatError: { zh: "JSON格式错误", en: "JSON format error" },
  submitSuccess: { zh: "提交成功", en: "Submit success" },
  noConfigConnectUrl: { zh: "未配置连接URL", en: "No URL configured" },
  connectSuccess: { zh: "连接成功", en: "Connect success" },
  connectClose: { zh: "连接关闭", en: "Connect close" },
  connectError: { zh: "连接异常", en: "Connect error" },
  confirmClosePage: { zh: "确定要关闭这一页吗", en: "Confirm to close this page?" },
  crop: { zh: "裁剪", en: "Crop" },
  hideNav: { zh: "隐藏导航栏", en: "Hide nav" },
  systemMessage: { zh: "系统消息", en: "System message" },
  details: { zh: "详情", en: "Details" },
  live: { zh: "实况", en: "Live" },
  noDeal: { zh: "不处置", en: "Not dispose of" },
  targetDetected : { zh: "发现可疑目标",en:"Suspicious target detected"},
  placeholder: { zh: "从网页或其他应用软件复制表格数据，粘贴到这里 。默认第一行是表头，使用回车键添加新行，使用Tab键区分列。", en: "Copy table data from web pages or other application software, paste it here. The first row is the header by default, add a new row using the Enter key, and use the Tab key to separate columns." },
  title: { zh: "机器人管控平台", en: "Robot control platform" },
  select: { zh: "选择", en: "Select" },
  offline: { zh: "离线", en: "Offline" },
  online: { zh: "在线", en: "Online" },
  power: { zh: "电量", en: "Power" },
  speedHtml: { zh: "速度", en: "Speed" },
  accelerationHtml: { zh: "加速度", en: "Acceleration" },
  direction: { zh: "方向", en: "Direction" },
  pleaseSelect: { zh: "请选择", en: "Please select" },
  confirmDeleteSchedule: { zh: "确定删除此调度任务吗？", en: "Confirm to delete the schedule task?" },
  executionLog: { zh: "日志", en: "Log" },
  scheduleStartTime: { zh: "调度开始时间", en: "Schedule start time" },
  createTime: { zh: "创建时间", en: "Create time" },
  recordCreateTime: { zh: "记录创建时间", en: "Record creation time" },
  failureReason: { zh: "失败原因", en: "Failure reason" },
  noExecutionLog: { zh: "暂无执行日志", en: "No execution log" },
  failed: { zh: "失败", en: "Failed" },
  tenantManagement: { zh: '租户管理', en: 'Tenant management' },
  tenantCode: { zh: '租户编码', en: 'Tenant code' },
  tenantName: { zh: '租户名称', en: 'Tenant name' },
  addTenant: { zh: '新增租户', en: 'Add tenant' },
  normal: { zh: '正常', en: 'Normal' },
  modifyInfo: { zh: '修改信息', en: 'Modify info' },
  tenantCodeRequired: { zh: '请输入租户编码', en: 'Please enter tenant code' },
  tenantNameRequired: { zh: '请输入租户名称', en: 'Please enter tenant name' },
  confirmModifyTenantStatus: { zh: '确定要修改租户状态吗?', en: 'Confirm to modify tenant status?' },
  adminPhone: { zh: '管理员手机号', en: 'Admin phone' },
  adminCode: { zh: '管理员账号', en: 'Admin code' },
  adminName: { zh: '管理员用户名', en: 'Admin name' },
  adminPwd: { zh: '管理员密码', en: 'Admin password' },
  adminPhoneRequired: { zh: '请输入管理员手机号', en: 'Please enter admin phone' },
  adminCodeRequired: { zh: '请输入管理员账号', en: 'Please enter admin code' },
  adminNameRequired: { zh: '请输入管理员用户名', en: 'Please enter admin name' },
  adminPwdRequired: { zh: '请输入管理员密码', en: 'Please enter admin password' },
  adminEmail: { zh: '管理员邮箱', en: 'Admin email' },
  adminEmailRequired: { zh: '请输入管理员邮箱', en: 'Please enter admin email' },
  freeze: { zh: '冻结', en: 'Freeze' },
  viewUsers: { zh: '查看用户', en: 'View users' },
  email: { zh: '邮箱', en: 'Email' },
  screenResolutionError: { zh: '当前屏幕分辨率为 ${width}x${height}，系统要求最低分辨率为 1366x768，请调整屏幕分辨率或使用标准显示器后重试', en: 'Current screen resolution is ${width}x${height}, system requires minimum resolution of 1366x768, please adjust screen resolution or use standard display and try again' },
  loginSuccess: { zh: '登录成功', en: 'Login successful' },
  loginPlaceholder: { zh: '请输入账号或者手机号', en: 'Please enter account or phone number' },
  passwordPlaceholder: { zh: '请输入密码', en: 'Please enter password' },
  loginButton: { zh: '登录', en: 'Login' },
  forgotPasswordModalTitle: { zh: '忘记密码弹窗', en: 'Forgot password dialog' },
  pleaseInputEmail: { zh: '请输入邮箱', en: 'Please input email' },
  emailFormatError: { zh: '邮箱格式错误', en: 'Invalid email format' },
  forgotPassword: { zh: '忘记密码', en: 'Forgot password' },
  resetPassword: { zh: '重置密码', en: 'Reset password' },
  accountOrPhone: { zh: '账户/手机号', en: 'Account/phone' },
  pleaseInputAccountOrPhone: { zh: '请输入账户或手机号', en: 'Please input account or phone' },
  verificationCode: { zh: '验证码', en: 'Verification code' },
  pleaseInputVerificationCode: { zh: '请输入验证码', en: 'Please input verification code' },
  sendVerificationCode: { zh: '发送验证码', en: 'Send verification code' },
  newPassword: { zh: '新密码', en: 'New password' },
  pleaseInputNewPassword: { zh: '请输入新密码', en: 'Please input new password' },
  resendAfterSeconds: { zh: '秒后重新发送', en: 's to resend' },
  verificationCodeSent: { zh: '验证码已发送', en: 'Verification code sent' },
  sendVerificationCodeFailed: { zh: '发送验证码失败', en: 'Failed to send verification code' },
  resetPasswordSuccess: { zh: '密码重置成功', en: 'Password reset successfully' },
  resetPasswordFailed: { zh: '密码重置失败', en: 'Password reset failed' },
  exposeNotEmpty: { zh: '三方对外账户不能为空', en: 'Expose account cannot be empty' },
  exposeNameNotEmpty: { zh: '三方名称不能为空', en: 'Expose name cannot be empty' },
  exposePwdNotEmpty: { zh: '三方连接密码不能为空', en: 'Expose password cannot be empty' },
  exposeAccount: { zh: '对外账户', en: 'Expose account' },
  exposePwd: { zh: '连接密码', en: 'Expose password' },
  tenantList: { zh: '租户列表', en: 'Tenant list' },
  selectTenantFirst: { zh: '请先选择租户', en: 'Please select tenant first' },
  addExpose: { zh: '新增三方账户', en: 'Add expose' },
  exposeListForTenant: { zh: '的三方账户列表', en: "'s Expose list"},
  exposeName: { zh: '三方名称', en: 'Expose name' },
  chineseNotAllowed: { zh: '不能包含中文', en: 'Chinese not allowed' },
  robotMoveManagement: { zh: '机器人迁移', en: 'Robot move management' },
  moveTenant: { zh: '迁移', en: 'Move' },
  targetTenant: { zh: '目标租户', en: 'Target tenant' },
  refreshCache: { zh: '刷新缓存', en: 'Refresh cache' },
  refreshingCache: { zh: '正在刷新缓存...', en: 'Refreshing cache...' },
  returnToBase: { zh: '返回基地', en: 'Return to base' },
  confirmReturnToBase: { zh: '确定让机器人返回基地吗？', en: 'Confirm to return the robot to the base?' },
  ntpSync: { zh: 'NTP同步', en: 'NTP Sync' },
  confirmNtpSync: { zh: '确定对该机器人执行NTP时间同步吗？', en: 'Confirm to perform NTP time sync for this robot?' },
  cycleDetails: { zh: '详情', en: 'Cycle details' },
  pathName: { zh: '路径名称', en: 'Path name' },
  nodeName: { zh: '节点名称', en: 'Node name' },
  remoteControl: { zh: '遥控', en: 'Remote control' },
  programControl: { zh: '程控', en: 'Program control' },
  originalArea: { zh: '原始区域', en: 'Original area' },
  copy: { zh: '点击复制', en: 'Click to copy' },
  copySuccess: { zh: '复制成功', en: 'Copy success' },
  originalPath: { zh: '原始路径', en: 'Original path' },
  import: { zh: '导入', en: 'Import' },
  imported: { zh: '已导入', en: 'Imported' },
  importData: { zh: '导入数据', en: 'Import data' },
  dataCannotBeEmpty: { zh: '数据不能为空', en: 'Data cannot be empty' },
  coordinateFormatError: { zh: '坐标格式错误', en: 'Coordinate format error' },
  importSuccess: { zh: '导入成功', en: 'Import success' },
  noImportData: { zh: '没有导入数据', en: 'No import data' },
  musicUpload: { zh: '音频上传', en: 'Audio upload' },
  uploadedMusic:{zh:'已上传音频',en:'Uploaded audio'},
  deleteMusic:{zh:'删除音频',en:'Delete audio'},
  deleteMusicConfirm:{zh:'确定删除音频吗？',en:'Confirm to delete audio?'},
  deleteMusicSuccess:{zh:'删除音频成功',en:'Delete audio success'},
  deleteMusicFailed:{zh:'删除音频失败',en:'Delete audio failed'},
  error: {zh: '错误',en: 'Error'},
  'sync.files': {zh: '同步文件', en: 'Synchronize files'},
  'stopIntercom': {zh: '停止喊话', en: 'Stop voice announcement'},
  'stopIntercomFailed': {zh: '停止喊话失败', en: 'Stop voice announcement failed'},
  'checkingIntercom': {zh: '检查喊话状态', en: 'Checking voice announcement status'},
  'checkIntercomStatusFailed': {zh: '检查喊话状态失败', en: 'Check voice announcement status failed'},
  'intercomStoppedSuccessfully': {zh: '喊话已停止', en: 'Voice announcement stopped successfully'},
  'play.status': {zh: '播放状态', en: 'Play status'},
  'play.status.playing': {zh: '播放中', en: 'Playing'},
  'shuffle.play': {zh: '随机播放', en: 'Shuffle play'},
  'sequence.play': {zh: '顺序播放', en: 'Sequence play'},
  'single.play': {zh: '单曲循环', en: 'Single play'},
  'mute': {zh: '静音', en: 'Mute'},
  'unmute': {zh: '取消静音', en: 'Unmute'},
  'volume.adjust': {zh: '音量调节', en: 'Volume adjust'},
  'playlist': {zh: '音频列表', en: 'Audio list'},
  'get_song_list_error': {zh: '获取音频列表失败', en: 'Get audio list failed'},
  'cmd_resp_audio_play_success': {zh: '音频播放控制成功', en: 'Audio play control success'},
  'cmd_resp_audio_volume_success': {zh: '音频音量控制成功', en: 'Audio volume control success'},
  'cmd_resp_audio_mute_success': {zh: '音频静音状态控制成功', en: 'Audio mute control success'},
  'cmd_resp_sound_file_success': {zh: '音频文件同步响应成功', en: 'Audio file synchronization response success'},
  'cmd_resp_audio_play_error': {zh: '音频播放控制响应错误', en: 'Audio play control response error'},
  'cmd_resp_audio_volume_error': {zh: '音频音量控制响应错误', en: 'Audio volume control response error'},
  'cmd_resp_audio_mute_error': {zh: '音频静音状态控制响应错误', en: 'Audio mute control response error'},
  'cmd_resp_sound_file_error': {zh: '音频文件同步响应错误', en: 'Audio file synchronization response error'},
  'sync_robot_error': {zh: '同步请求发送失败', en: 'Sync request send failed'},
  'robot.list': {zh: '机器人列表', en: 'Robot list'},
  'uploaded_music': {zh: '已上传音频', en: 'Uploaded audio'},
  'please_select_robot': {zh: '请选择机器人', en: 'Please select a robot'},
  workVisionPleaseSelectRobot: { zh: '请先选择机器人', en: 'Please select a robot first' },
  workVisionNoRobotData: { zh: '暂无可展示的工况数据，请先分配机器人', en: 'No work condition data available. Please assign a robot first' },
  workVisionNoRobotVideo: { zh: '暂无可播放的工况视频，请先分配机器人', en: 'No work condition video available. Please assign a robot first' },
  'music_upload': {zh: '音频上传', en: 'Audio upload'},
  'only_support_mp3_format': {zh: '仅支持 MP3 格式', en: 'MP3 format only'},
  'drag_mp3_file_here': {zh: '将MP3文件拖放到此处', en: 'Drag and drop MP3 files here'},
  'or_click_to_select_file': {zh: '或点击选择文件', en: 'or click to select files'},
  'start_upload': {zh: '开始上传', en: 'Start upload'},
  'clear_list': {zh: '清空列表', en: 'Clear list'},
  'get_robot_list_error': {zh: '获取机器人列表失败', en: 'Get robot list failed'},
  'switch_tip': {zh: '切换提示', en: 'Switch tip'},
  'switch_tip_content': {zh: '当前有未上传完成的文件，切换将清空上传列表，是否继续？', en: 'There are files that have not been uploaded, switching will clear the upload list, continue?'},
  'continue_switch': {zh: '继续切换', en: 'Continue switch'},
  'upload_failed': {zh: '上传失败', en: 'Upload failed'},
  'upload_failed_desc': {zh: '上传失败', en: 'Upload failed'},
  'upload_success_desc': {zh: '上传成功', en: 'Upload success'},
  'unknown_error': {zh: '未知错误', en: 'Unknown error'},
  'over_50mb_size_limit': {zh: '超过50MB大小限制', en: 'Over 50MB size limit'},
  'not_mp3_format_file': {zh: '不是MP3格式文件', en: 'Not MP3 format file'},
  'already_in_upload_list': {zh: '已在上传列表中', en: 'Already in upload list'},
  'download_address_not_exist': {zh: '下载地址不存在', en: 'Download address not exist'},
  'confirm_delete': {zh: '确认删除', en: 'Confirm delete'},
  'confirm_delete_content': {zh: '确定要删除这个音频文件吗？', en: 'Confirm to delete this audio file?'},
  'tip': {zh: '提示', en: 'Tip'},
  'delete_success': {zh: '删除成功', en: 'Delete success'},
  'delete_failed': {zh: '删除失败', en: 'Delete failed'},
  'delete_failed_desc': {zh: '删除失败', en: 'Delete failed'},
  'confirm_clear': {zh: '确认清空', en: 'Confirm clear'},
  'confirm_clear_content': {zh: '确定要清空上传列表吗？', en: 'Confirm to clear the upload list?'},
  'file_read_failed': {zh: '文件读取失败', en: 'File read failed'},
  'file_read_failed_desc': {zh: '文件读取失败', en: 'File read failed'},
  'file_read_failed_desc': {zh: '文件读取失败', en: 'File read failed'},
  'config_not_found': {zh: '未找到配置信息', en: 'Configuration not found'},
  'file_access_address_not_configured': {zh: '未配置文件访问地址', en: 'File access address not configured'},
  noAudioFiles:{ zh: '无音频文件', en: 'No audio file' },
  adjustVolume: { zh: '调节音量', en: 'Adjust volume' },
  songList: { zh: '音频列表', en: 'Audio list' },
  closeSongList: { zh: '关闭音频列表', en: 'Close audio list' },
  playCommandSuccess: { zh: '操作命令成功', en: 'Operation command success' },
  playModeSuccess: { zh: '播放模式切换成功', en: 'Play mode change success' },
  pauseOrResumeSuccess: { zh: '暂停/恢复成功', en: 'Pause/resume success' },
  setVolumeSuccess: { zh: '设置音量成功', en: 'Set volume success' },
  toggleMuteSuccess: { zh: '切换静音成功', en: 'Toggle mute success' },
  playListSuccess: { zh: '播放列表操作成功', en: 'Playlist operation success' },
  playCommandError: { zh: '操作命令失败', en: 'Operation command error' },
  playModeError: { zh: '播放模式切换失败', en: 'Play mode change error' },
  pauseOrResumeError: { zh: '暂停/恢复失败', en: 'Pause/resume error' },
  setVolumeError: { zh: '设置音量失败', en: 'Set volume error' },
  toggleMuteError: { zh: '切换静音失败', en: 'Toggle mute error' },
  playListError: { zh: '播放列表操作失败', en: 'Playlist operation error' },
  unknownError: { zh: '未知错误', en: 'Unknown error' },
  preparingPleaseWait: { zh: '正在准备中，请稍候', en: 'Preparing, please wait' },
  noSongsAvailable: { zh: '没有可用的音频', en: 'No audio available' },
  currentPlay: { zh: '当前播放', en: 'Current playing' },
  nextSong: { zh: '下一个', en: 'Next audio' },
  previousSong: { zh: '上一个', en: 'Previous audio' },
  randomPlay: { zh: '随机播放', en: 'Random play' },
  sequencePlay: { zh: '顺序播放', en: 'Sequence play' },
  singleLoop: { zh: '单曲循环', en: 'Single loop' },
  preparing: { zh: '准备中', en: 'Preparing' },
  previousPage: { zh: '上一页', en: 'Previous page' },
  nextPage: { zh: '下一页', en: 'Next page' },
  syncSuccess: { zh: '同步成功', en: 'Sync success' },
  sequencePlayEnabled: { zh: '顺序播放模式已启用', en: 'Sequence play mode enabled' },
  randomPlayEnabled: { zh: '随机播放模式已启用', en: 'Random play mode enabled' },
  singleLoopEnabled: { zh: '单曲循环模式已启用', en: 'Single loop mode enabled' },
  muteSuccess: { zh: '静音成功', en: 'Muted successfully' },
  unmuteSuccess: { zh: '取消静音成功', en: 'Unmuted successfully' },
  volumeSetSuccess: { zh: '音量设置成功', en: 'Volume set successfully' },
  playSuccess: { zh: '开始播放', en: 'Started playing' },
  pauseSuccess: { zh: '已暂停', en: 'Paused' },
  stopSuccess: { zh: '已停止', en: 'Stopped' },
  nextSongSuccess: { zh: '已切换到下一个', en: 'Switched to next audio' },
  previousSongSuccess: { zh: '已切换到上一个', en: 'Switched to previous audio' },

  // Voice Intercom related translations
  pleaseSelectRobot: { zh: '请选择机器人', en: 'Please select robot' },
  systemDefault: { zh: '系统默认', en: 'System default' },
  callConnected: { zh: '已与', en: 'Connected with' },
  callEnded: { zh: '通话已结束', en: 'Call ended' },
  checkingDeviceStatus: { zh: '检查设备状态中...', en: 'Checking device status...' },
  startIntercom: { zh: '开始喊话', en: 'Start voice announcement' },
  endIntercom: { zh: '结束喊话', en: 'End voice announcement' },
  devicePreparing: { zh: '设备准备中', en: 'Device preparing' },
  waitingDeviceConnection: { zh: '等待设备连接', en: 'Waiting for device connection' },
  intercomInProgress: { zh: '喊话中', en: 'Voice announcement in progress' },
  ended: { zh: '已结束', en: 'Ended' },
  robotOfflineCannotCall: { zh: '该机器人当前离线，无法建立通话', en: 'This robot is currently offline and cannot establish a call' },
  establishedCallConnection: { zh: '建立通话连接', en: 'Established call connection' },
  
  // Missing translations from main.vue
  threeDDashboard: { zh: '三维看板', en: '3D Dashboard' },
  swConfigNotFound: { zh: '未找到三维看板配置信息', en: 'Configuration not found' },
  openFailed: { zh: '打开三维看板失败', en: 'Failed to open 3D dashboard' },
  systemError: { zh: '系统错误', en: 'System error' },
  elementNotFound: { zh: '找不到选择框元素', en: 'Select element not found' },
  second: { zh: '秒', en: 's' },
  customize: { zh: '自定义', en: 'customize' },
  enterValidTime: { zh: '请输入有效的时间', en: 'Please enter a valid time' },
  reminderNotGiveAgain: { zh: '已设置{seconds}秒内不再提醒', en: 'Reminder will not be given again within {seconds} seconds' },

  // Audio Properties related translations
  robotListTitle: { zh: '机器人列表', en: 'Robot list' },
  speakerVolume: { zh: '扬声器音量', en: 'Speaker volume' },
  robotOfflineCannotSelect: { zh: '该机器人当前离线，无法选择', en: 'This robot is currently offline and cannot be selected' },
  getRobotListFailed: { zh: '获取机器人列表失败', en: 'Failed to get robot list' },

  // Music Upload related translations
  uploadedAudio: { zh: '已上传音频', en: 'Uploaded audio' },
  deleteAudioConfirm: { zh: '确定要删除这个音频文件吗？', en: 'Are you sure you want to delete this audio file?' },
  deleteAudioSuccess: { zh: '删除成功', en: 'Delete success' },
  deleteAudioFailed: { zh: '删除失败', en: 'Delete failed' },

  // Common voice interface translations
  connectingToRobot: { zh: '正在连接到', en: 'Connecting to' },
  connecting: { zh: '建立连接中...', en: 'Connecting...' },
  voiceIntercomTitle: { zh: '语音喊话', en: 'Voice announcement' },
  audioPlaybackTitle: { zh: '音频播放', en: 'Audio playback' },
  audioUploadTitle: { zh: '音频上传', en: 'Audio upload' },
  audioPropertiesTitle: { zh: '音频属性', en: 'Audio properties' },

  // Camera switching translations
  switchCamera: { zh: '切换视角', en: 'Switch view' },
  selectView: { zh: '选择视角', en: 'Select view' },
  cameraLeftFront: { zh: '左前', en: 'Left front' },
  cameraLeftRear: { zh: '左后', en: 'Left rear' },
  cameraRightFront: { zh: '右前', en: 'Right front' },
  cameraRightSide: { zh: '右后', en: 'Right rear' },
  cameraLeftFrontRightRear: { zh: '左前右后', en: 'Left front right rear' },
  cameraLeftRearRightFront: { zh: '左后右前', en: 'Left rear right front' },
  cameraPanoramicFront: { zh: '前拼接', en: 'Front splice' },
  cameraPanoramicRear: { zh: '后拼接', en: 'Rear splice' },
  cameraInfraredLeftRear: { zh: '红外左后', en: 'Infrared left rear' },
  cameraInfraredRightFront: { zh: '红外右前', en: 'Infrared right front' },
  
  // Video player control translations
  videoPlayPause: { zh: '播放/暂停', en: 'Play/Pause' },
  videoMute: { zh: '静音', en: 'Mute' },
  videoUnmute: { zh: '取消静音', en: 'Unmute' },
  videoFullscreen: { zh: '全屏', en: 'Fullscreen' },
  videoExitFullscreen: { zh: '退出全屏', en: 'Exit fullscreen' },

  // Additional voice intercom translations
  environmentNotSupported: { zh: '当前环境不支持媒体设备访问，请使用localhost或HTTPS访问', en: 'Current environment does not support media device access, please use localhost or HTTPS' },
  webrtcNotSupported: { zh: '不支持webrtc, 无法进行语音喊话', en: 'WebRTC not supported, unable to perform voice intercom' },
  iceNegotiationError: { zh: 'ICE 协商出错', en: 'ICE negotiation error' },
  offerAnswerExchangeFailed: { zh: 'offer anwser 交换失败', en: 'Offer answer exchange failed' },
  captureStreamFailed: { zh: '捕获流失败，请检查麦克风权限', en: 'Capture stream failed, please check microphone permissions' },
  robotPlayingMusic: { zh: '机器人正在播放', en: 'Robot is playing' },
  stopMusicAndStartIntercom: { zh: '，是否停止音频播放并开始语音喊话？', en: ', do you want to stop audio play and start voice announcement?' },
  stopMusic: { zh: '停止音频', en: 'Stop audio' },
  cancelIntercom: { zh: '取消喊话', en: 'Cancel voice announcement' },
  stopMusicPlaybackFailed: { zh: '停止音频播放失败', en: 'Failed to stop audio play' },
  musicPlaybackStopped: { zh: '已停止音频播放', en: 'Audio play stopped' },
  robotNotSelectedOrIdFailed: { zh: '未选择机器人或获取机器人ID失败', en: 'Robot not selected or failed to get robot ID' },
  voiceIntercomInitFailed: { zh: '语音喊话初始化失败', en: 'Voice announcement initialization failed' },
  robotIntercomActiveStopToPlay: { zh: '该机器人正在进行语音喊话，需要先停止喊话才能播放音频。是否停止喊话？', en: 'This robot is currently in voice announcement mode. You need to stop the voice announcement first to play audio. Do you want to stop the voice announcement?' },
  robotIntercomActiveCannotCall: { zh: '该机器人语音喊话已被占用，您无法进行喊话', en: 'The robot is currently in voice announcement mode and cannot be called.' },
  // Audio Properties Panel translations
  selectRobotToViewAudioProperties: { zh: '请选择机器人以查看音频属性', en: 'Please select a robot to view audio properties' },
  selectRobotFromLeftListToConfigureAudio: { zh: '选择左侧列表中的机器人来配置音频参数', en: 'Select a robot from the left list to configure audio parameters' },
  volumeSettings: { zh: '音量设置', en: 'Volume settings' },
  volumeSetTo: { zh: '音量已设置为', en: 'Volume set to' },
  volumeUpdateSuccess: { zh: '音量更新成功', en: 'Volume update successful' },
  volumeUpdateFailed: { zh: '音量更新失败', en: 'Volume update failed' },

  // Status translations
  online: { zh: '在线', en: 'Online' },
  offline: { zh: '离线', en: 'Offline' },

  // Audio Properties Panel additional translations
  audioStatus: { zh: '音频状态', en: 'Audio status' },
  connectionStatus: { zh: '连接状态', en: 'Connection status' },
  normal: { zh: '正常', en: 'Normal' },
  connected: { zh: '已连接', en: 'Connected' },
  audioCodecFormat: { zh: '音频编码格式', en: 'Audio codec format' },
  pcmaCodec: { zh: 'PCMA（G.711 A律）', en: 'PCMA (G.711 A-law)' },
  sampleRate: { zh: '采样率', en: 'Sample rate' },
  audioChannel: { zh: '声道', en: 'Audio channel' },
  monoChannel: { zh: '1（单声道）', en: '1 (Mono)' },
  configurationEnableSuccess: { zh: '启用成功', en: 'Enable successful' },
  configurationDisableSuccess: { zh: '禁用成功', en: 'Disable successful' },
  deleteConfigurationMessage: { zh: '确定要删除配置', en: 'Are you sure to delete this configuration' },

  // Multicast Configuration translations
  multicastConfigManagement: { zh: '组播配置管理', en: 'Multicast configuration management' },
  addConfiguration: { zh: '新增配置', en: 'Add configuration' },
  refresh: { zh: '刷新', en: 'Refresh' },
  loading: { zh: '加载中...', en: 'Loading...' },
  noMulticastConfig: { zh: '暂无组播配置', en: 'No multicast configuration' },
  clickAddConfigTip: { zh: '点击右上角"新增配置"按钮添加配置', en: 'Click "Add Configuration" button in the top right corner to add configuration' },
  enabled: { zh: '启用', en: 'Enabled' },
  disabled: { zh: '禁用', en: 'Disabled' },
  ipAddress: { zh: 'IP地址', en: 'IP address' },
  telecontrolPort: { zh: '遥控端口', en: 'Telecontrol port' },
  telemetryPort: { zh: '遥测端口', en: 'Telemetry port' },
  videoPort: { zh: '视频端口', en: 'Video port' },
  associatedRobots: { zh: '关联机器人', en: 'Associated robots' },
  editMulticastConfig: { zh: '编辑组播配置', en: 'Edit multicast configuration' },
  addMulticastConfig: { zh: '新增组播配置', en: 'Add multicast configuration' },
  configurationName: { zh: '配置名称', en: 'Configuration name' },
  pleaseEnterConfigName: { zh: '请输入配置名称', en: 'Please enter configuration name' },
  whetherToEnable: { zh: '是否启用', en: 'Whether to enable' },
  selectRobots: { zh: '选择机器人', en: 'Select robots' },
  update: { zh: '更新', en: 'Update' },
  loadConfigFieldsFailed: { zh: '加载配置字段失败', en: 'Failed to load configuration fields' },
  getConfigInfoFailed: { zh: '获取配置信息失败', en: 'Failed to get configuration information' },
  saveSuccessful: { zh: '保存成功', en: 'Save successful' },
  updateSuccessful: { zh: '更新成功', en: 'Update successful' },
  saveFailed: { zh: '保存失败', en: 'Save failed' },
  pleaseEnterCorrectIPFormat: { zh: '请输入正确的IP地址格式', en: 'Please enter correct IP address format' },
  pleaseEnterValidPort: { zh: '请输入有效的端口号', en: 'Please enter valid port number' },
  portRangeIs: { zh: '端口范围为', en: 'Port range is' },
  pleaseEnterValidNumber: { zh: '请输入有效的数字', en: 'Please enter valid number' },
  numberCannotBeLessThan: { zh: '数字不能小于', en: 'Number cannot be less than' },
  numberCannotBeGreaterThan: { zh: '数字不能大于', en: 'Number cannot be greater than' },
  lengthShouldBeBetween: { zh: '长度应在', en: 'Length should be between' },
  charactersRange: { zh: '个字符之间', en: ' characters' },
  onlyChineseCharacters: { zh: '只能输入中文字符', en: 'Only Chinese characters allowed' },
  onlyEnglishCharacters: { zh: '只能输入英文字符', en: 'Only English characters allowed' },
  onlyLettersAndNumbers: { zh: '只能输入字母和数字', en: 'Only letters and numbers allowed' },
  noSpecialCharacters: { zh: '不能包含特殊字符', en: 'Cannot contain special characters' },
  unknownValidationType: { zh: '未知的验证类型', en: 'Unknown validation type' },
  configNameLengthRange: { zh: '配置名称长度在1到50个字符', en: 'Configuration name length should be 1 to 50 characters' },
  pleaseEnter: { zh: '请输入', en: 'Please enter ' },

  // Robot Selector translations
  selectRobot: { zh: '选择机器人', en: 'Select robot' },
  searchRobotPlaceholder: { zh: '搜索机器人名称或编号', en: 'Search robot name or code' },
  selectedCount: { zh: '已选择', en: 'Selected' },
  selectAll: { zh: '全选', en: 'Select all' },
  clearSelection: { zh: '清空选择', en: 'Clear selection' },
  loadingRobots: { zh: '加载中...', en: 'Loading...' },
  noMatchingRobots: { zh: '未找到匹配的机器人', en: 'No matching robots found' },
  noRobotData: { zh: '暂无机器人数据', en: 'No robot data available' },
  confirmSelection: { zh: '确定', en: 'Confirm' },
  getRobotListFailed: { zh: '获取机器人列表失败', en: 'Failed to get robot list' },

  // 3D Dashboard translations
  threeDDashboard: { zh: '三维看板', en: '3D dashboard' },
  swConfigNotFound: { zh: '三维看板配置未找到', en: '3D dashboard configuration not found' },
  openFailed: { zh: '打开三维看板失败', en: 'Failed to open 3D dashboard' },
  // Video player related
  clickToPlay: { zh: '点击播放', en: 'Click to play' },
  streamErrorTip: { zh: '视频流加载失败', en: 'Video stream loading failed' },

  // Smart Config related translations
  smartConfigTitle: { zh: '智能配置', en: 'Smart configuration' },
  selectRobotToViewSmartConfig: { zh: '请选择机器人以查看智能配置', en: 'Please select a robot to view smart configuration' },
  selectRobotFromLeftListToConfigureSmartSettings: { zh: '选择左侧列表中的机器人来配置智能设置', en: 'Select a robot from the left list to configure smart settings' },
  behaviorProhibitionConfig: { zh: '行为拒止配置', en: 'Behavior prohibition configuration' },
  behaviorProhibitionEnable: { zh: '行为拒止使能', en: 'Behavior prohibition enable' },
  confirmEnableBehaviorProhibition: { zh: '确认启用行为拒止功能？', en: 'Confirm to enable behavior prohibition function?' },
  confirmDisableBehaviorProhibition: { zh: '确认禁用行为拒止功能？', en: 'Confirm to disable behavior prohibition function?' },
  behaviorProhibitionEnabled: { zh: '行为拒止已启用', en: 'Behavior prohibition enabled' },
  behaviorProhibitionDisabled: { zh: '行为拒止已禁用', en: 'Behavior prohibition disabled' },
  lowBatteryThreshold: { zh: '低电量阈值', en: 'Low Battery Threshold' },
  currentThreshold: { zh: '当前阈值', en: 'Current Threshold' },
  lowBatteryThresholdUpdated: { zh: '低电量阈值已更新为', en: 'Low battery threshold updated to' },
  confirmOperation: { zh: '确认操作', en: 'Confirm operation' },
  operationFailed: { zh: '操作失败', en: 'Operation failed' },
  cameraViewConfig: { zh: '相机视角配置', en: 'Camera View Configuration' },
  leftFront: { zh: '左前', en: 'Left Front' },
  leftRear: { zh: '左后', en: 'Left Rear' },
  rightFront: { zh: '右前', en: 'Right Front' },
  rightRear: { zh: '右后', en: 'Right Rear' },
  leftFrontRightRear: { zh: '左前右后', en: 'Left Front & Right Rear' },
  leftRearRightFront: { zh: '左后右前', en: 'Left Rear & Right Front' },
  frontViewStitch: { zh: '前拼接', en: 'Front View Stitch' },
  rearViewStitch: { zh: '后拼接', en: 'Rear View Stitch' },
  infraredLeftRear: { zh: '红外左后', en: 'Infrared Left Rear' },
  infraredRightFront: { zh: '红外右前', en: 'Infrared Right Front' },
  selectedCameras: { zh: '已选择', en: 'Selected' },
  cameras: { zh: '个相机', en: 'camera(s)' },
  cameraConfigUpdated: { zh: '相机配置已更新', en: 'Camera configuration updated' },
  frontCamera: { zh: '前方监控', en: 'Front camera' },
  rearCamera: { zh: '后方监控', en: 'Rear camera' },
  switchCamera: { zh: '切换摄像头', en: 'Switch camera' },
  frontRightRearLeft: { zh: '前右后左', en: 'Front right & rear left' },

  frontLeftRearRight: { zh: '前左后右', en: 'Front left & rear right' },
  frontPanoramic: { zh: '前全景', en: 'Front panoramic' },
  rearPanoramic: { zh: '后全景', en: 'Rear panoramic' },
  selectView: { zh: '选择视角', en: 'Select view' },
  codeLabel: { zh: '编号', en: 'Code' },
  
  // Intercom UserCard.vue translations
  getRobotListErrorTitle: { zh: '错误', en: 'Error' },
  getTip: { zh: '提示', en: 'Tip' },
  
  // Intercom index.vue translations  
  selectRobotPrompt: { zh: '请选择机器人', en: 'Please select robot' },
  systemDefaultTitle: { zh: '系统默认', en: 'System default' },
  establishedConnection: { zh: '已与', en: 'Established connection with' },
  connectionEstablished: { zh: '建立通话连接', en: ' connection established' },
  callHasEnded: { zh: '通话已结束', en: 'Call has ended' },
  
  // Path import related translations
  formatJsonButton: { zh: '格式化JSON', en: 'Format JSON' },
  inputDataFirst: { zh: '请先输入数据', en: 'Please input data first' },
  formatSuccess: { zh: '格式化成功', en: 'Format successful' },
  
  // Coordinate conversion related translations
  coordinateConversionFailed: { zh: '坐标转换失败', en: 'Coordinate conversion failed' },
  saveNodeFailed: { zh: '保存节点失败', en: 'Failed to save node' },
  mapMarkerRestore: { zh: '地图标记已还原', en: 'Map marker restored' },
  fieldRequired: { zh: '此字段必填', en: 'This field is required' },
  mustBeNumber: { zh: '必须为数字', en: 'Must be a number' },
  coordinateRangeError: { zh: '坐标范围不正确', en: 'Coordinate range error' },
  wgs84Coordinate: { zh: 'WGS84经纬度', en: 'WGS84 Coordinate' },
  longitude: { zh: '经度', en: 'Longitude' },
  latitude: { zh: '纬度', en: 'Latitude' },
  
  // Batch delete related translations
  pleaseSelectNodesToDelete: { zh: '请选择要删除的节点', en: 'Please select nodes to delete' },
  removedFromList: { zh: '已从列表移除', en: 'Removed from list' },
  nodeCounts: { zh: '个节点', en: ' node(s)' },
  clickSaveButtonToConfirmDelete: { zh: '点击保存按钮确认删除', en: 'Click save button to confirm deletion' },
  // Distance related translations
  refDistance: { zh: '参考距离', en: 'Reference distance' },
  noCoordinateData: { zh: '暂无坐标', en: 'No coordinates' },
  
  // Skeleton Graph related translations
  skeletonGraph: { zh: '骨架图', en: 'Skeleton graph' },
  skeletonGraphManage: { zh: '骨架图管理', en: 'Skeleton graph management' },
  newSkeletonGraph: { zh: '新建骨架图', en: 'New skeleton graph' },
  exportData: { zh: '导出数据', en: 'Export data' },
  manualConnection: { zh: '手动连线', en: 'Manual connection' },
  exitConnection: { zh: '退出连线', en: 'Exit connection' },
  validate: { zh: '验证', en: 'Validate' },
  viewTopology: { zh: '查看拓扑图', en: 'View topology' },
  editPoints: { zh: '编辑点位', en: 'Edit points' },
  nodeCount: { zh: '节点数量', en: 'Node count' },
  edgeCount: { zh: '连线数量', en: 'Connection count' },
  clickToImport: { zh: '点击导入', en: 'Click to import' },
  dragNodeTip: { zh: '拖拽节点调整位置', en: 'Drag nodes to adjust position' },
  deleteConfirmContent: { zh: '确定删除此骨架图吗？', en: 'Confirm to delete this skeleton graph?' },
  skeletonGraphNameRequired: { zh: '骨架图名称不能为空', en: 'Skeleton graph name cannot be empty' },
  skeletonGraphStationRequired: { zh: '归属站点不能为空', en: 'Belonging station cannot be empty' },
  skeletonGraphNodesRequired: { zh: '节点数据不能为空', en: 'Node data cannot be empty' },
  skeletonGraphNodesMinRequired: { zh: '至少需要2个节点', en: 'At least 2 nodes required' },
  skeletonGraphSaveSuccess: { zh: '骨架图保存成功', en: 'Skeleton graph saved successfully' },
  skeletonGraphSaveFailed: { zh: '骨架图保存失败', en: 'Skeleton graph save failed' },
  skeletonGraphDeleteSuccess: { zh: '骨架图删除成功', en: 'Skeleton graph deleted successfully' },
  skeletonGraphDeleteFailed: { zh: '骨架图删除失败', en: 'Skeleton graph delete failed' },
  skeletonGraphLoadFailed: { zh: '骨架图加载失败', en: 'Skeleton graph load failed' },
  skeletonGraphValidationFailed: { zh: '骨架图验证失败', en: 'Skeleton graph validation failed' },
  skeletonGraphImportSuccess: { zh: '数据导入成功', en: 'Data imported successfully' },
  skeletonGraphImportFailed: { zh: '数据导入失败', en: 'Data import failed' },
  skeletonGraphExportSuccess: { zh: '数据导出成功', en: 'Data exported successfully' },
  skeletonGraphExportFailed: { zh: '数据导出失败', en: 'Data export failed' },
  skeletonGraphFileUpload: { zh: '文件上传', en: 'File upload' },
  skeletonGraphManualInput: { zh: '手动输入', en: 'Manual input' },
  supportedFormat: { zh: '支持格式', en: 'Supported format' },
  maxSize: { zh: '最大', en: 'Max size' },
  skeletonGraphFormatJson: { zh: '格式化', en: 'Format' },
  skeletonGraphPaste: { zh: '粘贴', en: 'Paste' },
  skeletonGraphClear: { zh: '清空', en: 'Clear' },
  skeletonGraphJsonRequired: { zh: 'JSON数据不能为空', en: 'JSON data cannot be empty' },
  skeletonGraphJsonInvalid: { zh: 'JSON格式不正确', en: 'Invalid JSON format' },
  skeletonGraphNodeIdRequired: { zh: '节点ID不能为空', en: 'Node ID cannot be empty' },
  skeletonGraphNodeIdDuplicate: { zh: '节点ID重复', en: 'Duplicate node ID' },
  skeletonGraphNodeLonInvalid: { zh: '节点经度无效', en: 'Invalid node longitude' },
  skeletonGraphNodeLatInvalid: { zh: '节点纬度无效', en: 'Invalid node latitude' },
  skeletonGraphEdgeFromRequired: { zh: '边起点不能为空', en: 'Edge from cannot be empty' },
  skeletonGraphEdgeToRequired: { zh: '边终点不能为空', en: 'Edge to cannot be empty' },
  skeletonGraphEdgeFromNotFound: { zh: '边起点节点不存在', en: 'Edge from node not found' },
  skeletonGraphEdgeToNotFound: { zh: '边终点节点不存在', en: 'Edge to node not found' },
  skeletonGraphEdgeSelfLoop: { zh: '边不能自连', en: 'Edge cannot be self-loop' },
  skeletonGraphEdgeDirectionInvalid: { zh: '边方向无效', en: 'Invalid edge direction' },
  skeletonGraphEdgeDuplicate: { zh: '边重复', en: 'Duplicate edge' },
  skeletonGraphIsolatedNodes: { zh: '存在孤立节点', en: 'Isolated nodes exist' },
  skeletonGraphConnectionModeActive: { zh: '连线模式已激活', en: 'Connection mode activated' },
  skeletonGraphConnectionModeExit: { zh: '已退出连线模式', en: 'Exited connection mode' },
  skeletonGraphSelectTwoNodes: { zh: '请选择两个节点进行连线', en: 'Please select two nodes to connect' },
  skeletonGraphEdgeCreated: { zh: '边创建成功', en: 'Edge created successfully' },
  skeletonGraphEdgeDeleted: { zh: '边删除成功', en: 'Edge deleted successfully' },
  skeletonGraphSmartPathCreated: { zh: '智能路径创建成功', en: 'Smart path created successfully' },
  skeletonGraphNoPathFound: { zh: '未找到路径', en: 'No path found' },
  skeletonGraphDirectEdgeCreated: { zh: '直接边创建成功', en: 'Direct edge created successfully' },
  skeletonGraphTopologyValid: { zh: '拓扑图验证通过', en: 'Topology validation passed' },
  skeletonGraphTopologyInvalid: { zh: '拓扑图验证失败', en: 'Topology validation failed' },
  skeletonGraphFileSizeLimit: { zh: '文件大小不能超过10MB', en: 'File size cannot exceed 10MB' },
  skeletonGraphFileFormatError: { zh: '仅支持.json文件', en: 'Only .json files supported' },
  skeletonGraphParseError: { zh: '数据解析失败', en: 'Data parsing failed' },
  skeletonGraphNoData: { zh: '暂无骨架图数据', en: 'No skeleton graph data' },
  skeletonGraphClickRowToView: { zh: '点击表格行查看骨架图', en: 'Click table row to view skeleton graph' },
  skeletonGraphMapFocused: { zh: '地图已定位到骨架图', en: 'Map focused on skeleton graph' },
  skeletonGraphTableRowSelected: { zh: '表格行已选中', en: 'Table row selected' },
  twoWay: { zh: '双向', en: 'Two-way' },
  oneWay: { zh: '单向', en: 'One-way' },
  direction: { zh: '方向', en: 'Direction' },
  nodes: { zh: '节点', en: 'Nodes' },
  edges: { zh: '边', en: 'Edges' },
  topology: { zh: '拓扑图', en: 'Topology' },
  graphInfo: { zh: '骨架图信息', en: 'Graph info' },
  graphData: { zh: '骨架图数据', en: 'Graph data' },
  importMode: { zh: '导入方式', en: 'Import mode' },
  parseResult: { zh: '解析结果', en: 'Parse result' },
  errorCount: { zh: '错误数量', en: 'Error count' },
  errorList: { zh: '错误列表', en: 'Error list' },
  jsonPreview: { zh: 'JSON预览', en: 'JSON preview' },
  dragFileHere: { zh: '将文件拖到此处，或', en: 'Drag file here, or' },
  clickUpload: { zh: '点击上传', en: 'Click to upload' },
  pasteJsonHere: { zh: '在此粘贴JSON数据', en: 'Paste JSON data here' },
  confirmImport: { zh: '确认导入', en: 'Confirm import' },
  cancelImport: { zh: '取消导入', en: 'Cancel import' },
  topologyCanvas: { zh: '拓扑图画布', en: 'Topology canvas' },
  closeTopology: { zh: '关闭拓扑图', en: 'Close topology' },
  nodePosition: { zh: '节点位置', en: 'Node position' },
  edgeConnection: { zh: '边连接', en: 'Edge connection' },
  graphStatistics: { zh: '图统计', en: 'Graph statistics' },
  totalNodes: { zh: '总节点数', en: 'Total nodes' },
  totalEdges: { zh: '总边数', en: 'Total edges' },
  bidirectionalEdges: { zh: '双向边', en: 'Bidirectional edges' },
  unidirectionalEdges: { zh: '单向边', en: 'Unidirectional edges' },
  inputDescription: { zh: '请输入描述', en: 'Please enter description' },
  deleteConfirm: { zh: '确认删除', en: 'Confirm delete' },
  deleteSuccess: { zh: '删除成功', en: 'Delete successfully' },
  formatSuccess: { zh: '格式化成功', en: 'Format successfully' },
  failed: { zh: '失败', en: 'Failed' },
  confirmDeleteEdge: { zh: '确定删除这条边吗？', en: 'Confirm to delete this edge?' },
  selectSecondNode: { zh: '请选择第二个节点', en: 'Please select the second node' },
  edgeAlreadyExists: { zh: '边已存在', en: 'Edge already exists' },
  allEdgesExist: { zh: '所有边都已存在', en: 'All edges already exist' },
  cancelEditConfirm: { zh: '确定取消编辑吗？未保存的更改将丢失', en: 'Confirm to cancel editing? Unsaved changes will be lost' },
  saveSuccess: { zh: '保存成功', en: 'Save successfully' },
  // Skeleton Graph related translations
  skeletonGraphManage: { zh: '骨架图管理', en: 'Skeleton graph management' },
  newSkeletonGraph: { zh: '新建骨架图', en: 'New skeleton graph' },
  skeletonGraphBasicInfo: { zh: '基础信息', en: 'Basic information' },
  skeletonGraphName: { zh: '骨架图名称', en: 'Skeleton graph name' },
  skeletonGraphNamePlaceholder: { zh: '请输入骨架图名称', en: 'Please enter skeleton graph name' },
  skeletonGraphNameRequired: { zh: '名称不能为空', en: 'Name cannot be empty' },
  skeletonGraphBelongStationRequired: { zh: '请选择归属站点', en: 'Please select belonging station' },
  skeletonGraphSelectStation: { zh: '请选择站点', en: 'Please select station' },
  skeletonGraphDescPlaceholder: { zh: '请输入描述信息', en: 'Please enter description' },
  skeletonGraphNodeManage: { zh: '节点管理', en: 'Node managemen' },
  skeletonGraphMapAdd: { zh: '地图添加', en: 'Map add' },
  skeletonGraphExitAdd: { zh: '退出添加', en: 'Exit' },
  skeletonGraphDataImport: { zh: '数据导入', en: 'Data import' },
  skeletonGraphManualConnect: { zh: '手动连线', en: 'Link' },
  skeletonGraphExitConnect: { zh: '退出连线', en: 'Exit' },
  skeletonGraphSmartConnect: { zh: '智能连线', en: 'Auto-Link' },
  skeletonGraphConnectSettings: { zh: '连线设置', en: 'Connect settings' },
  skeletonGraphManualConnectType: { zh: '手动连线类型', en: 'Manual connect type' },
  skeletonGraphDynamicConnectType: { zh: '动态连线类型', en: 'Dynamic connect type' },
  skeletonGraphRangeConnect: { zh: '范围连接', en: 'Range Connect' },
  skeletonGraphRangeConnectTip: { zh: '点击手动连线按钮后，依次点击两个节点，系统会连接这两个节点ID范围内的所有节点（如选择1和3，会创建1→2→3的连线）', en: 'After clicking the manual connect button, click two nodes in sequence, the system will connect all nodes within the ID range of these two nodes (e.g., selecting 1 and 3 will create connections 1→2→3)' },
  skeletonGraphInsertConnect: { zh: '插入连接', en: 'Insert Connect' },
  skeletonGraphInsertConnectTip: { zh: '地图添加节点或导入数据时，新节点自动连接到最后一个已存在的节点（如已有1→2→3，添加节点4后会创建3→4）', en: 'When adding nodes on the map or importing data, new nodes automatically connect to the last existing node (e.g., if there are 1→2→3, adding node 4 will create 3→4)' },
  skeletonGraphSequentialConnect: { zh: '顺序连接', en: 'Sequential Connect' },
  skeletonGraphSequentialConnectTip: { zh: '地图添加节点或导入数据时，新添加的节点之间按ID顺序依次连接，不与已有节点连接（如已有1→2→3，新增5、6、7后会创建5→6→7）', en: 'When adding nodes on the map or importing data, newly added nodes are connected in ID order without connecting to existing nodes (e.g., if there are 1→2→3, adding 5, 6, 7 will create 5→6→7)' },
  skeletonGraphNearestConnect: { zh: '近邻连接', en: 'Nearest Connect' },
  skeletonGraphNearestConnectTip: { zh: '地图添加节点或导入数据时，新节点自动连接到距离最近的已存在节点', en: 'When adding nodes on the map or importing data, new nodes automatically connect to the nearest existing node' },
  skeletonGraphNode: { zh: '节点', en: 'Node' },
  skeletonGraphNodeCount: { zh: '节点数量', en: 'Node count' },
  skeletonGraphEdgeCount: { zh: '连线数量', en: 'Edge count' },
  skeletonGraphDeleteNode: { zh: '删除节点', en: 'Delete node' },
  skeletonGraphDeleteNodeConfirm: { zh: '确定要删除此节点吗？关联的连线也将被删除。', en: 'Are you sure you want to delete this node? Associated connections will also be deleted.' },
  skeletonGraphNoNodes: { zh: '暂无节点', en: 'No nodes' },
  skeletonGraphNoNodesTip: { zh: '点击"地图添加"或"数据添加"添加节点', en: 'Click "Map Add" or "Data Import" to add nodes' },
  skeletonGraphEditMode: { zh: '编辑模式', en: 'Edit mode' },
  skeletonGraphTopology: { zh: '拓扑', en: 'Topology' },
  skeletonGraphDraft: { zh: '草稿', en: 'Draft' },
  skeletonGraphNodeCount: { zh: '节点数量', en: 'Node count' },
  skeletonGraphEdgeCount: { zh: '连线数量', en: 'Edge count' },
  skeletonGraphFormatJson: { zh: '格式化', en: 'Format' },
  skeletonGraphPaste: { zh: '粘贴', en: 'Paste' },
  skeletonGraphClear: { zh: '清空', en: 'Clear' },
  skeletonGraphClickUpload: { zh: '点击上传', en: 'Click to upload' },
  skeletonGraphPasteJsonHere: { zh: '粘贴JSON数据到此处', en: 'Paste JSON data here' },
  skeletonGraphJsonRequired: { zh: '请输入JSON数据', en: 'Please enter JSON data' },
  skeletonGraphFileFormatError: { zh: '文件格式错误，仅支持.json文件', en: 'File format error, only .json files are supported' },
  skeletonGraphFileSizeLimit: { zh: '文件大小不能超过10MB', en: 'File size cannot exceed 10MB' },
  skeletonGraphImportSuccess: { zh: '导入成功', en: 'Import successful' },
  skeletonGraphFormatSuccess: { zh: '格式化成功', en: 'Format successful' },
  skeletonGraphPasteSuccess: { zh: '粘贴成功', en: 'Paste successful' },
  skeletonGraphPasteFailed: { zh: '粘贴失败', en: 'Paste failed' },
  skeletonGraphValidationSuccess: { zh: '数据验证成功', en: 'Data validation successful' },
  skeletonGraphValidationFailed: { zh: '数据验证失败', en: 'Data validation failed' },
  skeletonGraphMinTwoNodes: { zh: '至少需要导入2个节点', en: 'At least 2 nodes are required' },
  skeletonGraphDataFormatError: { zh: '数据格式错误', en: 'Data format error' },
  skeletonGraphCoordConvertFailed: { zh: '坐标转换失败', en: 'Coordinate conversion failed' },
  skeletonGraphSaveSuccess: { zh: '保存成功', en: 'Save successful' },
  skeletonGraphSaveFailed: { zh: '保存失败', en: 'Save failed' },
  skeletonGraphUpdateSuccess: { zh: '更新成功', en: 'Update successful' },
  skeletonGraphUpdateFailed: { zh: '更新失败', en: 'Update failed' },
  skeletonGraphDeleteSuccess: { zh: '删除成功', en: 'Delete successful' },
  skeletonGraphDeleteFailed: { zh: '删除失败', en: 'Delete failed' },
  skeletonGraphDeleteConfirm: { zh: '确定删除此骨架图吗？', en: 'Are you sure you want to delete this skeleton graph?' },
  skeletonGraphCancelEdit: { zh: '取消编辑', en: 'Cancel edit' },
  skeletonGraphHasUnsavedChanges: { zh: '有未保存的更改，确定要退出编辑模式吗？', en: 'There are unsaved changes, are you sure you want to exit edit mode?' },
  skeletonGraphMapAddMode: { zh: '请在地图上点击位置添加节点', en: 'Please click on the map to add nodes' },
  skeletonGraphCancelMapAddMode: { zh: '已取消地图添加模式', en: 'Map add mode cancelled' },
  skeletonGraphManualConnectMode: { zh: '请依次点击两个节点进行连线', en: 'Please click two nodes in sequence to connect' },
  skeletonGraphCancelManualConnectMode: { zh: '已取消手动连线模式', en: 'Manual connect mode cancelled' },
  skeletonGraphNodeAdded: { zh: '节点已添加', en: 'Node added' },
  skeletonGraphEdgeAdded: { zh: '连线已添加', en: 'Edge added' },
  skeletonGraphNodeDeleted: { zh: '节点已删除', en: 'Node deleted' },
  skeletonGraphEdgeDeleted: { zh: '连线已删除', en: 'Edge deleted' },
  skeletonGraphNodeUpdated: { zh: '节点已更新', en: 'Node updated' },
  skeletonGraphTopologyView: { zh: '拓扑图查看', en: 'Topology View' },
  skeletonGraphTopologyViewTitle: { zh: '骨架图拓扑视图', en: 'Skeleton Graph Topology View' },
  skeletonGraphZoomIn: { zh: '放大', en: 'Zoom In' },
  skeletonGraphZoomOut: { zh: '缩小', en: 'Zoom Out' },
  skeletonGraphResetView: { zh: '重置视图', en: 'Reset View' },
  skeletonGraphBidirectional: { zh: '双向', en: 'Bidirectional' },
  skeletonGraphUnidirectional: { zh: '单向', en: 'Unidirectional' },
  skeletonGraphDistance: { zh: '距离', en: 'Distance' },
  skeletonGraphMeter: { zh: '米', en: 'meter' },
  skeletonGraphDeleteEdge: { zh: '删除连线', en: 'Delete Edge' },
  skeletonGraphDeleteEdgeConfirm: { zh: '确定要删除该连线吗？', en: 'Are you sure you want to delete this edge?' },
  skeletonGraphEdgeInfo: { zh: '连线信息', en: 'Edge Information' },
  skeletonGraphFromNode: { zh: '起始节点', en: 'From Node' },
  skeletonGraphToNode: { zh: '目标节点', en: 'To Node' },
  skeletonGraphEdgeDirection: { zh: '连线方向', en: 'Edge Direction' },
  skeletonGraphCoordValidationFailed: { zh: '坐标验证失败', en: 'Coordinate validation failed' },
  skeletonGraphLonRange: { zh: '经度必须在-180到180之间', en: 'Longitude must be between -180 and 180' },
  skeletonGraphLatRange: { zh: '纬度必须在-90到90之间', en: 'Latitude must be between -90 and 90' },
  skeletonGraphInvalidNumber: { zh: '请输入有效的数字', en: 'Please enter a valid number' },
  skeletonGraphImportNodesSuccess: { zh: '成功导入 {count} 个节点', en: 'Successfully imported {count} nodes' },
  skeletonGraphEdgesCreated: { zh: '已创建 {count} 条连线', en: '{count} edges created' },
  skeletonGraphAllEdgesExist: { zh: '所有连线已存在', en: 'All edges already exist' },
  skeletonGraphNodeInfo: { zh: '节点信息', en: 'Node Information' },
  skeletonGraphWgs84Lon: { zh: '经度', en: 'Longitude' },
  skeletonGraphWgs84Lat: { zh: '纬度', en: 'Latitude' },
  skeletonGraphNoDescription: { zh: '无', en: 'None' },
  skeletonGraphUnknown: { zh: '未知', en: 'Unknown' },
  skeletonGraphDeleteNodeTitle: { zh: '确认删除', en: 'Confirm Delete' },
  skeletonGraphDeleteNodeContent: { zh: '确定要删除该节点吗？关联的连线也将被删除。', en: 'Are you sure you want to delete this node? Associated edges will also be deleted.' },
  skeletonGraphDeleteEdgeTitle: { zh: '确认删除', en: 'Confirm Delete' },
  skeletonGraphDeleteEdgeContent: { zh: '确定要删除该连线吗？', en: 'Are you sure you want to delete this edge?' },
  skeletonGraphDeleteGraphTitle: { zh: '确认删除', en: 'Confirm Delete' },
  skeletonGraphDeleteGraphContent: { zh: '确定要删除该骨架图吗？删除后将无法恢复。', en: 'Are you sure you want to delete this skeleton graph? This action cannot be undone.' },
  skeletonGraphInputNodeData: { zh: '请输入节点数据', en: 'Please enter node data' },
  skeletonGraphDataFormatErrorTitle: { zh: '数据格式错误', en: 'Data Format Error' },
  skeletonGraphMinTwoNodesWarning: { zh: '至少需要导入2个节点', en: 'At least 2 nodes are required' },
  skeletonGraphCreatedSuccess: { zh: '骨架图已创建，请在地图上绘制连线后保存', en: 'Skeleton graph created, please draw edges on the map and save' },
  skeletonGraphCoordConvertError: { zh: '坐标转换失败，节点数据无效，请检查节点坐标是否正确', en: 'Coordinate conversion failed, node data invalid, please check node coordinates' },
  skeletonGraphImportNodesSuccessMsg: { zh: '成功导入 {count} 个节点', en: 'Successfully imported {count} nodes' },
  skeletonGraphNotFound: { zh: '未找到骨架图数据', en: 'Skeleton graph data not found' },
  skeletonGraphEditModeInfo: { zh: '编辑模式：可以编辑节点、连线和基础信息', en: 'Edit mode: You can edit nodes, edges and basic information' },
  skeletonGraphMinOneEdgeWarning: { zh: '请至少绘制一条连线', en: 'Please draw at least one edge' },
  skeletonGraphSaveFailedMsg: { zh: '保存失败', en: 'Save failed' },
  skeletonGraphCancelMapAddModeMsg: { zh: '已取消地图添加模式', en: 'Map add mode cancelled' },
  skeletonGraphMapAddModeMsg: { zh: '请在地图上点击位置添加节点', en: 'Please click on the map to add nodes' },
  skeletonGraphExitManualConnectMode: { zh: '已退出手动连线模式', en: 'Exited manual connect mode' },
  skeletonGraphManualConnectModeOn: { zh: '手动连线模式已开启，依次点击两个节点创建连线', en: 'Manual connect mode enabled, click two nodes in sequence to create connection' },
  skeletonGraphCannotConnectSame: { zh: '不能连接到同一个节点', en: 'Cannot connect to the same node' },
  skeletonGraphNotEnoughNodes: { zh: '节点范围内没有足够的节点', en: 'Not enough nodes in range' },
  skeletonGraphEdgeAlreadyExists: { zh: '这两个节点之间已存在连线', en: 'Edge already exists between these two nodes' },
  skeletonGraphNodeNotExist: { zh: '节点不存在', en: 'Node does not exist' },
  skeletonGraphNodeCoordUpdated: { zh: '节点坐标已更新', en: 'Node coordinates updated' },
  skeletonGraphNodeSelected: { zh: '已选中节点 {id}，请点击目标节点', en: 'Node {id} selected, please click target node' },
  skeletonGraphCannotConnectSelf: { zh: '不能连接到自己', en: 'Cannot connect to itself' },
  skeletonGraphSmartPathCreated: { zh: '智能路径已创建', en: 'Smart path created' },
  skeletonGraphCoordConvertFailedTitle: { zh: '坐标转换失败', en: 'Coordinate Conversion Failed' },
  skeletonGraphCoordConvertFailedDesc: { zh: '无法转换坐标，请检查网络连接或稍后重试', en: 'Unable to convert coordinates, please check network connection or try again later' },
  skeletonGraphStationName: { zh: '归属站点', en: 'Station' },
  skeletonGraphPopupTitle: { zh: '骨架图信息', en: 'Skeleton Graph Info' },
  skeletonGraphExitManualConnectMsg: { zh: '已退出手动连线模式', en: 'Manual connect mode exited' },
  skeletonGraphManualConnectModeMsg: { zh: '手动连线模式已开启，依次点击两个节点创建连线', en: 'Manual connect mode enabled, click two nodes in sequence to create edge' },
  skeletonGraphCannotConnectSameNode: { zh: '不能连接到同一个节点', en: 'Cannot connect to the same node' },
  skeletonGraphNotEnoughNodesInRange: { zh: '节点范围内没有足够的节点', en: 'Not enough nodes in range' },
  skeletonGraphAllEdgesExistWarning: { zh: '所有连线已存在', en: 'All edges already exist' },
  skeletonGraphEdgeAlreadyExists: { zh: '这两个节点之间已存在连线', en: 'Edge already exists between these two nodes' },
  skeletonGraphNodeNotExist: { zh: '节点不存在', en: 'Node does not exist' },
  skeletonGraphNodeDeletedSuccess: { zh: '节点已删除', en: 'Node deleted' },
  skeletonGraphCoordConvertFailedTitle: { zh: '坐标转换失败', en: 'Coordinate Conversion Failed' },
  skeletonGraphCoordConvertFailedDesc: { zh: '无法转换坐标，请检查网络连接或稍后重试', en: 'Unable to convert coordinates, please check network connection or try again later' },
  skeletonGraphNodeUpdatedSuccess: { zh: '节点坐标已更新', en: 'Node coordinates updated' },
  skeletonGraphNodeSelectedMsg: { zh: '已选中节点 {id}，请点击目标节点', en: 'Node {id} selected, please click target node' },
  skeletonGraphCannotConnectToSelf: { zh: '不能连接到自己', en: 'Cannot connect to itself' },
  skeletonGraphEdgesCreatedSuccess: { zh: '已创建 {count} 条连线', en: '{count} edges created' },
  skeletonGraphAllEdgesExistInfo: { zh: '所有连线已存在', en: 'All edges already exist' },
  skeletonGraphEdgeDeletedSuccess: { zh: '连线已删除', en: 'Edge deleted' },
  skeletonGraphPasteSuccess: { zh: '粘贴成功', en: 'Paste successful' },
  skeletonGraphPasteFailed: { zh: '粘贴失败', en: 'Paste failed' },
  skeletonGraphInputValidNumber: { zh: '请输入有效的数字', en: 'Please enter a valid number' },
  skeletonGraphLonRangeError: { zh: '经度必须在-180到180之间', en: 'Longitude must be between -180 and 180' },
  skeletonGraphLatRangeError: { zh: '纬度必须在-90到90之间', en: 'Latitude must be between -90 and 90' },
  skeletonGraphDataValidationSuccess: { zh: '数据验证成功：共 {count} 个坐标点', en: 'Data validation successful: {count} coordinate points in total' },
  skeletonGraphDataValidationFailed: { zh: '数据验证失败：请检查数据格式是否为 [{"lng": Number, "lat": Number}, ...]', en: 'Data validation failed: Please check if the data format is [{"lng": Number, "lat": Number}, ...]' },
  skeletonGraphConfirmAdd: { zh: '确认添加', en: 'Confirm Add' },
  skeletonGraphPlaceholderExample: { zh: '格式示例：[{"lng":120.38305082258333,"lat":30.30},{"lng":120.384821091833,"lat":30.30}]', en: 'Format example: [{"lng":120.38305082258333,"lat":30.30},{"lng":120.384821091833,"lat":30.30}]' },
  nodeCount: { zh: '节点数量', en: 'Node count' },
  edgeCount: { zh: '连线数量', en: 'Edge count' },
  bidirectionalEdges: { zh: '双向连线', en: 'Bidirectional edges' },
  unidirectionalEdges: { zh: '单向连线', en: 'Unidirectional edges' },
  viewTopology: { zh: '查看拓扑', en: 'View topology' },
  close: { zh: '关闭', en: 'Close' },
  formatSuccess: { zh: '格式化成功', en: 'Format successful' },
  success: { zh: '成功', en: 'Success' },
  failed: { zh: '失败', en: 'Failed' },
  
  // Data Validator translations
  validatorLonMustBeNumber: { zh: '经度必须是有效的数字', en: 'Longitude must be a valid number' },
  validatorLonRange: { zh: '经度必须在-180到180之间', en: 'Longitude must be between -180 and 180' },
  validatorLatMustBeNumber: { zh: '纬度必须是有效的数字', en: 'Latitude must be a valid number' },
  validatorLatRange: { zh: '纬度必须在-90到90之间', en: 'Latitude must be between -90 and 90' },
  validatorGraphDataEmpty: { zh: '骨架图数据不能为空', en: 'Skeleton graph data cannot be empty' },
  validatorGraphNameEmpty: { zh: '骨架图名称不能为空', en: 'Skeleton graph name cannot be empty' },
  validatorStationRequired: { zh: '必须选择归属站点', en: 'Station must be selected' },
  validatorNodesFormatError: { zh: '节点数据格式错误', en: 'Node data format error' },
  validatorAtLeastOneNode: { zh: '至少需要一个节点', en: 'At least one node is required' },
  validatorNodeCoordInvalid: { zh: '节点{index}的坐标无效', en: 'Node {index} coordinates invalid' },
  validatorNodeMissingId: { zh: '节点{index}缺少ID', en: 'Node {index} missing ID' },
  validatorEdgeMissingFromNode: { zh: '连线{index}缺少起始节点ID', en: 'Edge {index} missing from node ID' },
  validatorEdgeFromNodeNotExist: { zh: '连线{index}的起始节点不存在', en: 'Edge {index} from node does not exist' },
  validatorEdgeMissingToNode: { zh: '连线{index}缺少目标节点ID', en: 'Edge {index} missing to node ID' },
  validatorEdgeToNodeNotExist: { zh: '连线{index}的目标节点不存在', en: 'Edge {index} to node does not exist' },
  validatorEdgeSameNode: { zh: '连线{index}的起始节点和目标节点不能相同', en: 'Edge {index} from and to nodes cannot be the same' },
  validatorJsonEmpty: { zh: 'JSON数据不能为空', en: 'JSON data cannot be empty' },
  validatorJsonFormatError: { zh: 'JSON格式错误', en: 'JSON format error' },
  validatorJsonParsedEmpty: { zh: 'JSON数据解析后为空', en: 'Parsed JSON data is empty' },
  validatorJsonArrayEmpty: { zh: 'JSON数据数组为空', en: 'JSON data array is empty' },
  validatorArrayElementEmpty: { zh: '数组元素{index}为空', en: 'Array element {index} is empty' },
  validatorArrayElementMissingCoord: { zh: '数组元素{index}缺少坐标信息', en: 'Array element {index} missing coordinate information' },
  validatorNodesArrayEmpty: { zh: 'nodes数组为空', en: 'nodes array is empty' },
  validatorObjectMissingCoord: { zh: '对象缺少坐标信息', en: 'Object missing coordinate information' },
  validatorJsonInvalidFormat: { zh: 'JSON数据格式不正确，应该是对象或数组', en: 'JSON data format incorrect, should be object or array' },
  validatorNodeDataEmpty: { zh: '节点数据不能为空', en: 'Node data cannot be empty' },
  validatorNodeIdEmpty: { zh: '节点ID不能为空', en: 'Node ID cannot be empty' },
  validatorEdgeDataEmpty: { zh: '连线数据不能为空', en: 'Edge data cannot be empty' },
  validatorEdgeMissingFromNodeId: { zh: '连线缺少起始节点ID', en: 'Edge missing from node ID' },
  validatorEdgeFromNodeNotExist: { zh: '连线的起始节点不存在', en: 'Edge from node does not exist' },
  validatorEdgeMissingToNodeId: { zh: '连线缺少目标节点ID', en: 'Edge missing to node ID' },
  validatorEdgeToNodeNotExist: { zh: '连线的目标节点不存在', en: 'Edge to node does not exist' },
  validatorEdgeSameNodes: { zh: '连线的起始节点和目标节点不能相同', en: 'Edge from and to nodes cannot be the same' },
  
  // Coordinate Converter translations
  coordConverterInvalidData: { zh: '坐标数据包含无效值', en: 'Coordinate data contains invalid values' },
  coordConverterLengthMismatch: { zh: '坐标转换返回数据长度不匹配', en: 'Coordinate conversion returned data length mismatch' },
  coordConverterInvalidResult: { zh: '坐标转换返回数据包含无效值', en: 'Coordinate conversion returned invalid values' },
  coordConverterGcj02ToWgs84Failed: { zh: '经纬度转换失败', en: 'Latitude and longitude conversion failed' },
  coordConverterWgs84ToGcj02Failed: { zh: '经纬度转换失败', en: 'Latitude and longitude conversion failed' },
  coordConverterFailed: { zh: '坐标转换失败', en: 'Coordinate conversion failed' },
  
  // Data Parser translations
  parserFormatError: { zh: '数据格式错误：必须是坐标数组，格式为 [{lng: Number, lat: Number}, ...]', en: 'Data format error: must be coordinate array in format [{lng: Number, lat: Number}, ...]' },
  parserDataEmpty: { zh: '数据不能为空：至少需要一个坐标点', en: 'Data cannot be empty: at least one coordinate point required' },
  parserPointMustBeObject: { zh: '坐标点 {index}: 必须是一个对象', en: 'Coordinate point {index}: must be an object' },
  parserPointMissingLng: { zh: '坐标点 {index}: 缺少 lng 字段', en: 'Coordinate point {index}: missing lng field' },
  parserPointMissingLat: { zh: '坐标点 {index}: 缺少 lat 字段', en: 'Coordinate point {index}: missing lat field' },
  parserLngMustBeNumber: { zh: '坐标点 {index}: lng 必须是数字类型', en: 'Coordinate point {index}: lng must be a number' },
  parserLatMustBeNumber: { zh: '坐标点 {index}: lat 必须是数字类型', en: 'Coordinate point {index}: lat must be a number' },
  parserLngRange: { zh: '坐标点 {index}: lng 必须在 -180 到 180 之间', en: 'Coordinate point {index}: lng must be between -180 and 180' },
  parserLatRange: { zh: '坐标点 {index}: lat 必须在 -90 到 90 之间', en: 'Coordinate point {index}: lat must be between -90 and 90' },
  parserJsonParseFailed: { zh: 'JSON 解析失败', en: 'JSON parse failed' },
  parserNodeMustBeObject: { zh: '节点 {index}: 必须是一个对象', en: 'Node {index}: must be an object' },
  parserNodeMissingId: { zh: '节点 {index}: 缺少 id 字段', en: 'Node {index}: missing id field' },
  parserNodeIdType: { zh: '节点 {index}: id 必须是数字或字符串', en: 'Node {index}: id must be a number or string' },
  parserNodeMissingLon: { zh: '节点 {index}: 缺少经度字段 (lon 或 longitude)', en: 'Node {index}: missing longitude field (lon or longitude)' },
  parserNodeLonType: { zh: '节点 {index}: 经度必须是数字', en: 'Node {index}: longitude must be a number' },
  parserNodeLonRange: { zh: '节点 {index}: 经度必须在 -180 到 180 之间', en: 'Node {index}: longitude must be between -180 and 180' },
  parserNodeMissingLat: { zh: '节点 {index}: 缺少纬度字段 (lat 或 latitude)', en: 'Node {index}: missing latitude field (lat or latitude)' },
  parserNodeLatType: { zh: '节点 {index}: 纬度必须是数字', en: 'Node {index}: latitude must be a number' },
  parserNodeLatRange: { zh: '节点 {index}: 纬度必须在 -90 到 90 之间', en: 'Node {index}: latitude must be between -90 and 90' },
  parserEdgeMustBeObject: { zh: '边 {index}: 必须是一个对象', en: 'Edge {index}: must be an object' },
  parserEdgeMissingFrom: { zh: '边 {index}: 缺少起始节点字段 (from 或 fromNodeId)', en: 'Edge {index}: missing from node field (from or fromNodeId)' },
  parserEdgeFromNotExist: { zh: '边 {index}: 起始节点 {id} 不存在', en: 'Edge {index}: from node {id} does not exist' },
  parserEdgeMissingTo: { zh: '边 {index}: 缺少目标节点字段 (to 或 toNodeId)', en: 'Edge {index}: missing to node field (to or toNodeId)' },
  parserEdgeToNotExist: { zh: '边 {index}: 目标节点 {id} 不存在', en: 'Edge {index}: to node {id} does not exist' },
  parserEdgeSelfConnect: { zh: '边 {index}: 节点不能连接到自己', en: 'Edge {index}: node cannot connect to itself' },
  parserEdgeWeightType: { zh: '边 {index}: 权重必须是数字', en: 'Edge {index}: weight must be a number' },
  parserEdgeWeightPositive: { zh: '边 {index}: 权重必须大于 0', en: 'Edge {index}: weight must be greater than 0' },
  parserJsonFormatError: { zh: 'JSON 格式错误', en: 'JSON format error' },
  
  // Topology Validator translations
  topoValidatorNodesMustBeArray: { zh: '节点必须是数组', en: 'Nodes must be an array' },
  topoValidatorAtLeastOneNode: { zh: '至少需要一个节点', en: 'At least one node is required' },
  topoValidatorNodeMustBeObject: { zh: '节点 {index}: 必须是一个对象', en: 'Node {index}: must be an object' },
  topoValidatorNodeMissingId: { zh: '节点 {index}: 缺少 id 字段', en: 'Node {index}: missing id field' },
  topoValidatorDuplicateIds: { zh: '发现重复的节点 ID：{ids}', en: 'Duplicate node IDs found: {ids}' },
  topoValidatorEdgesMustBeArray: { zh: '边必须是数组', en: 'Edges must be an array' },
  topoValidatorEdgeMustBeObject: { zh: '边 {index}: 必须是一个对象', en: 'Edge {index}: must be an object' },
  topoValidatorEdgeMissingFrom: { zh: '边 {index}: 缺少起始节点', en: 'Edge {index}: missing from node' },
  topoValidatorEdgeFromNotExist: { zh: '边 {index}: 起始节点 {id} 不存在', en: 'Edge {index}: from node {id} does not exist' },
  topoValidatorEdgeMissingTo: { zh: '边 {index}: 缺少目标节点', en: 'Edge {index}: missing to node' },
  topoValidatorEdgeToNotExist: { zh: '边 {index}: 目标节点 {id} 不存在', en: 'Edge {index}: to node {id} does not exist' },
  topoValidatorEdgeSelfConnect: { zh: '边 {index}: 节点不能连接到自己', en: 'Edge {index}: node cannot connect to itself' },
  topoValidatorDuplicateEdges: { zh: '发现 {count} 条重复边', en: 'Found {count} duplicate edges' },
  topoValidatorIsolatedNodes: { zh: '发现 {count} 个孤立节点：{ids}', en: 'Found {count} isolated nodes: {ids}' },
  topoValidatorGraphNotConnected: { zh: '骨架图不是连通图', en: 'Skeleton graph is not connected' },
  topoValidatorGraphNotConnectedDesc: { zh: '骨架图必须是一个连通图，所有节点必须通过连线连接在一起，不能存在孤立的节点或节点组。请检查并添加必要的连线。', en: 'Skeleton graph must be a connected graph where all nodes are linked together through edges. There cannot be isolated nodes or node groups. Please check and add necessary edges.' },
  
  // Path Planning Skeleton Graph Display
  showSkeletonGraph: { zh: '显示骨架图', en: 'Show Skeleton Graph' },
  
  // Timezone related translations
  timezone: { zh: '时区', en: 'Timezone' },
  setTimezone: { zh: '设置时区', en: 'Set timezone' },
  timezoneSettings: { zh: '时区设置', en: 'Timezone settings' },
  selectTimezone: { zh: '选择时区', en: 'Select timezone' },
  searchTimezone: { zh: '搜索时区', en: 'Search timezone' },
  currentTimezone: { zh: '当前时区', en: 'Current timezone' },
  timezoneNotSet: { zh: '未设置', en: 'Not set' },
  confirmSetTimezone: { zh: '确定要设置时区吗？', en: 'Confirm to set timezone?' },
  timezoneSetSuccess: { zh: '时区设置指令已发送', en: 'Timezone setting command sent' },
  timezoneSetFailed: { zh: '时区设置失败', en: 'Failed to set timezone' },
  timezoneUpdateTip: { zh: '指令已发送，设备同步需要时间，如列表数据未更新，请稍后重新查询。', en: 'Command sent. Device sync takes time, if list data not updated, please query again later.' },
  refreshList: { zh: '刷新列表', en: 'Refresh list' },
  iKnow: { zh: '我知道了', en: 'I know' },
  timezoneSearchTip: { zh: '可输入关键词搜索时区', en: 'Search timezone by keyword' },
  pursuitTitle: { zh: '行为拒止', en: 'Pursuit Denial' },
  pursuitLiveEvent: { zh: '实时事件', en: 'LIVE EVENT' },
  pursuitDetection: { zh: '检测消息', en: 'Detection Messages' },
  pursuitHistoryEvents: { zh: '历史授权事件', en: 'Authorization History' },
  pursuitCurrentEvent: { zh: '当前事件', en: 'Current Event' },
  pursuitTargetId: { zh: '目标 ID', en: 'Target ID' },
  pursuitEventId: { zh: '事件 ID', en: 'Event ID' },
  pursuitEventStatus: { zh: '事件状态', en: 'Event Status' },
  pursuitTrackingStatus: { zh: '跟踪状态', en: 'Tracking Status' },
  pursuitTrackingTime: { zh: '跟踪更新时间', en: 'Tracking Update Time' },
  pursuitLatestFeedback: { zh: '最近反馈', en: 'Latest Feedback' },
  pursuitSourceReportTime: { zh: '来源检测时间', en: 'Source Detection Time' },
  pursuitStartTime: { zh: '开始时间', en: 'Start Time' },
  pursuitCloseTime: { zh: '关闭时间', en: 'Close Time' },
  pursuitWorkCondition: { zh: '球侧工况', en: 'Ball-side Condition' },
  pursuitRealtimeConnection: { zh: '数据通信', en: 'Data Communication' },
  pursuitOperation: { zh: '操作', en: 'Operation' },
  pursuitCancel: { zh: '取消行为拒止', en: 'Cancel Pursuit Denial' },
  pursuitNoOperation: { zh: '暂无可用操作', en: 'No operation available' },
  pursuitNoActiveEvent: { zh: '暂无活跃行为拒止事件', en: 'No active pursuit event' },
  pursuitDetectionTime: { zh: '检测时间', en: 'Detection Time' },
  pursuitEventTime: { zh: '事件时间', en: 'Event Time' },
  pursuitSelectDetectionTime: { zh: '选择检测时间范围', en: 'Select detection time range' },
  pursuitSelectEventTime: { zh: '选择事件时间范围', en: 'Select event time range' },
  pursuitCommandNotice: { zh: '操作提示', en: 'Command Notice' },
  pursuitCommandFailed: { zh: '操作失败', en: 'Command Failed' },
  pursuitDetailUnavailable: { zh: '无法查看详情', en: 'Details Unavailable' },
  pursuitDetailRobotMissing: { zh: '当前机器人列表中未找到详情对应的机器人：', en: 'The robot for these details is not in the current robot list:' },
  pursuitDetailRobotsUnavailable: { zh: '机器人列表加载失败或为空，请重新进入页面或选择机器人后查询', en: 'The robot list could not be loaded or is empty. Reopen the page or select a robot to search.' },
  pursuitLogTimestamp: { zh: '时间戳', en: 'Timestamp' },
  pursuitLogType: { zh: '事件类型', en: 'Event Type' },
  pursuitLogStatus: { zh: '状态', en: 'Status' },
  pursuitQuery: { zh: '查询', en: 'Search' },
  pursuitReset: { zh: '重置', en: 'Reset' },
  pursuitTotal: { zh: '总数', en: 'Total' },
  pursuitJump: { zh: '跳转', en: 'Go to' },
  pursuitNoData: { zh: '暂无数据', en: 'No data available' },
  pursuitTargetList: { zh: '目标列表', en: 'Target List' },
  pursuitSelectTarget: { zh: '选择一个目标进行授权', en: 'Select a target to authorize' },
  pursuitAuthorize: { zh: '授权行为拒止', en: 'Authorize Pursuit Denial' },
  pursuitHistoryDetail: { zh: '历史事件详情', en: 'Historical Event Details' },
  pursuitActive: { zh: '当前活跃', en: 'Active' },
  pursuitEnded: { zh: '已结束', en: 'Ended' },
  pursuitOperationHistory: { zh: '操作历史', en: 'Operation History' },
  pursuitOperationType: { zh: '操作类型', en: 'Operation Type' },
  pursuitOperationStatus: { zh: '操作状态', en: 'Operation Status' },
  pursuitOperationTime: { zh: '操作时间', en: 'Operation Time' },
  pursuitFeedback: { zh: '反馈信息', en: 'Feedback' },
  pursuitFeedbackTime: { zh: '反馈时间', en: 'Feedback Time' },
  pursuitRequestId: { zh: '请求 ID', en: 'Request ID' },
  pursuitStatusAuthorizing: { zh: '授权中', en: 'Authorizing' },
  pursuitStatusActive: { zh: '行为拒止中', en: 'Pursuit Denial Active' },
  pursuitStatusAuthorizeFailed: { zh: '授权失败', en: 'Authorization Failed' },
  pursuitStatusAuthorizeTimeout: { zh: '授权超时', en: 'Authorization Timeout' },
  pursuitStatusCancelling: { zh: '取消中', en: 'Cancelling' },
  pursuitStatusCancelFailed: { zh: '取消失败，可重试', en: 'Cancellation Failed, Retry Available' },
  pursuitStatusCancelTimeout: { zh: '取消超时，可重试', en: 'Cancellation Timeout, Retry Available' },
  pursuitStatusCanceled: { zh: '已取消', en: 'Canceled' },
  pursuitStatusPlatformClosed: { zh: '平台关闭', en: 'Platform Closed' },
  pursuitTrackingDetecting: { zh: '正在搜索目标', en: 'Searching for Target' },
  pursuitTracking: { zh: '正在跟踪', en: 'Tracking' },
  pursuitTrackingLost: { zh: '目标丢失，行为拒止失败', en: 'Target Lost, Pursuit Denial Failed' },
  pursuitConditionSnapshotEmpty: { zh: '暂无工况快照', en: 'No condition snapshot' },
  pursuitConditionBackup: { zh: '备班', en: 'Standby' },
  pursuitConditionPatrol: { zh: '巡逻', en: 'Patrolling' },
  pursuitConditionLowBattery: { zh: '低电量', en: 'Low Battery' },
  pursuitConditionActive: { zh: '行为拒止中', en: 'Pursuit Denial Active' },
  pursuitConditionUnknown: { zh: '工况', en: 'Condition' },
  pursuitAnnotatedImage: { zh: '检测标注图', en: 'Annotated detection image' },
  pursuitOperationPreparing: { zh: '准备发送', en: 'Preparing to Send' },
  pursuitOperationWaiting: { zh: '等待球侧反馈', en: 'Waiting for Ball Feedback' },
  pursuitOperationSuccess: { zh: '操作成功', en: 'Operation Succeeded' },
  pursuitOperationFailed: { zh: '球侧执行失败', en: 'Ball-side Execution Failed' },
  pursuitSendFailed: { zh: '发送失败', en: 'Send Failed' },
  pursuitResponseTimeout: { zh: '响应超时', en: 'Response Timeout' },
  pursuitStale: { zh: '已失效', en: 'Stale' },
  pursuitAuthorizeShort: { zh: '授权', en: 'Authorize' },
  pursuitCancelShort: { zh: '取消', en: 'Cancel' },
  pursuitNoticeTitle: { zh: '行为拒止消息', en: 'Pursuit Denial Message' },
  pursuitNoticeType: { zh: '类型', en: 'Type' },
  pursuitNoticeCode: { zh: '球编号', en: 'Ball Code' },
  pursuitNoticeTargetState: { zh: '目标/状态', en: 'Target/State' },
  pursuitNoticeDetail: { zh: '查看详情', en: 'View Details' },
  pursuitNoticeDetection: { zh: '检测消息', en: 'Detection Message' },
  pursuitNoticeTracking: { zh: '跟踪状态', en: 'Tracking Status' },
  pursuitNoticeEvent: { zh: '事件状态', en: 'Event Status' },
  pursuitNoticeFallback: { zh: '行为拒止消息', en: 'Pursuit Denial Message' },
  pursuitNoticePending: { zh: '待查看', en: 'Pending Review' },
  pursuitNoticeUnspecified: { zh: '未指定', en: 'Unspecified' },
  pursuitMonitorConnecting: { zh: '连接中', en: 'Connecting' },
  pursuitMonitorConnected: { zh: '已连接', en: 'Connected' },
  pursuitMonitorDisconnected: { zh: '未连接', en: 'Disconnected' },
  pursuitMonitorError: { zh: '连接异常', en: 'Connection Error' },
  pursuitNoStatus: { zh: '暂无状态', en: 'No status' },
}

export default language;
